/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { getUserFacingError } from "../../utils/userFacingError";
import RadioTwoToneIcon from "@mui/icons-material/RadioTwoTone";
import TvTwoToneIcon from "@mui/icons-material/TvTwoTone";
import AutoAwesomeTwoToneIcon from "@mui/icons-material/AutoAwesomeTwoTone";
import AddIcon from "@mui/icons-material/Add";
import AudiotrackTwoToneIcon from "@mui/icons-material/AudiotrackTwoTone";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import { Outlet } from "react-router-dom";
import { Topics } from "../../components/Topics";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { Title } from "../../components/Title";
import { Button } from "../../components/Button";
import { Select } from "../../components/Select";
import { ChevronDownIcon } from "@radix-ui/themes";
import { NumberField, TextField } from "../../components/Field";
import { parseHallAdComponents } from "./hallAd.utils";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { FloatContainer } from "../../components/FloatContainer";
import {
  FormControlLabel,
  FormGroup,
  Menu,
  MenuItem,
  Slider,
  Stack,
  Switch,
  SxProps,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faClose,
  faCog,
  faPaperPlane,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";
import { InfoPopup } from "../../components/InfoPopup";
import {
  adsPrice,
  createTurboUpload,
  getBandwidthMbps,
  isValidUrl,
  onlyIntegers,
} from "../../utils/utils";
import { adsAPI, RTA, sessionInfo } from "../..";
import { Chip } from "../../components/Chip";
import {
  AbcRounded,
  AbcSharp,
  DeleteRounded,
  EditRounded,
  FormatAlignCenterRounded,
  FormatAlignLeftRounded,
  FormatAlignRightRounded,
  ImageRounded,
  LabelRounded,
  LayersRounded,
  LinkRounded,
  PaletteRounded,
  PauseRounded,
  PlayArrowRounded,
  SmartButtonRounded,
  TextIncreaseRounded,
  TimerRounded,
  VerticalAlignCenterRounded,
  VideocamRounded,
} from "@mui/icons-material";
import { BannerFeedback } from "../../components/BannerFeedback";
import localforage from "localforage";
import { checkPermission, usePermissions } from "../../components/PermissionsContext";
import {
  AD_UPLOAD_SETTLED_EVENT,
  triggerUploadToastOpen,
  UPLOAD_BACKLOG_NOTICE,
} from "../../components/UploadToast";
import MonacoEditor from "@monaco-editor/react";
import { editor } from "monaco-editor";
import { useUser } from "../../components/UserContext";
import { InputTags } from "../../components/InputTags";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { formatCurrencyBRL } from "../../utils/formatCurrencyBRL";
import { inspectCreativeFile } from "../../utils/creativeFileValidation";
import { creativeAdultFlag, initialCreativeAdultFlag } from "../../utils/creativeAdultFlag";
import {
  ensureHallAdFonts,
  hallAdBackground,
  hallAdFont,
  hallAdStyle,
  hallAdStyleError,
  HALL_AD_FONTS,
  HALL_AD_HEIGHT,
  HALL_AD_WIDTH,
  serializeHallAdPart,
  toCanvasAdPart,
} from "../../media/hallAdCanvas";
import "../../media/hallAdCanvas.css";
import {
  buildMarketIndexView,
  isMarketIndexFeature,
  pacingLabel,
  type MarketIndexFeature,
  type MarketIndexResp,
  type PacingState,
} from "./marketIndex";
import "./ads.css";

const HALL_BOARD_WIDTH = HALL_AD_WIDTH;
const HALL_BOARD_HEIGHT = HALL_AD_HEIGHT;
const AVAILABLE_FONTS = HALL_AD_FONTS;

type AdsProps = {
  id: string;
  src: string;
  triggerLink: string;
  name: string;
  percentageRate?: number;
  tags: string[];
  active: boolean;
  isAdult: boolean;
  sizeMB: number;
  durationSec: number;
};

type PlayState = {
  playing: boolean;
  id: string;
};

type HallAdsProps = {
  id: string;
  components: string;
  label: string;
  headline?: string;
  percentageRate?: number;
  isAdult: boolean;
  active: boolean;
  tags: string[];
};

type HallAdComponentProps = {
  id: string;
  type: "button" | "text" | "image" | "background";
  src?: string;
  text?: string;
  link?: string;
  preview?: string;
  css: React.CSSProperties;
  zIndex: number;
  x: number;
  y: number;
  rotation: number;
  editorChangedSeed: string;
};

const menuSX: SxProps = {
  "& .MuiPaper-root": {
    backgroundColor: "var(--brand-a5)",
    color: "var(--brand-12)",
  },
};

function getSumPercentageRateAds(ads: AdsProps[] | HallAdsProps[]): number {
  return ads.reduce((sum, ad) => sum + (ad.percentageRate ?? 0), 0);
}

function calculateSumPercentageRateByTargetAdId(
  ads: AdsProps[] | HallAdsProps[],
  targetAdId: string,
  currentFrequency: number,
): number {
  return ads.reduce(
    (sum, ad) => (ad.id !== targetAdId ? sum + (ad.percentageRate ?? 0) : sum + currentFrequency),
    0,
  );
}

const LoadingAdsBudgetLimit: React.FC = () => {
  return (
    <div className="loadingAdsBudgetLimit">
      <SettingsRoundedIcon className="loadingAdsBudgetLimitIcon" />
      <span>Carregando limite de orçamento...</span>
    </div>
  );
};

export function Radio() {
  const { orgIsOnlyForAdults } = useUser();
  const [detailState, setDetailState] = React.useState<"create" | "edit">();
  const [activeFilter, setActiveFilter] = React.useState(true);
  const [play, setPlay] = React.useState<PlayState>({ playing: false, id: "" });
  const [ads, setAds] = React.useState<AdsProps[]>([]);
  const [search, setSearch] = React.useState("");
  const [loadingRadioBudget, setLoadingRadioBudget] = React.useState(true);
  const [radioBudgetLimit, setRadioBudgetLimit] = React.useState<number>(0);
  const [radioBudgetUsed, setRadioBudgetUsed] = React.useState<number>(0);
  const [hasRadioBudgetLimit, setHasRadioBudgetLimit] = React.useState<boolean>(false);
  const [radioMarketIndex, setRadioMarketIndex] = React.useState<MarketIndexFeature | null>(null);
  const [radioPacingState, setRadioPacingState] = React.useState<PacingState | undefined>(
    undefined,
  );
  const [bandwidthMbps] = React.useState(() => getBandwidthMbps());

  const [bannerFeedbackIsOpen, setBannerFeedbackIsOpen] = React.useState(false);
  const [bannerFeedbackType, setBannerFeedbackType] = React.useState<
    "error" | "success" | "warning" | "info"
  >("error");
  const [bannerFeedbackMessage, setBannerFeedbackMessage] = React.useState("");

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const candidateAdId = React.useRef<string>("");
  const bounceTimeNodeRef = React.useRef<NodeJS.Timeout | null>(null);
  const numBounceTimeRef = React.useRef<number>(300);
  const { permissions } = usePermissions();

  class SocketEvents {
    static async receiveNewUploadItem() {
      const info = await sessionInfo();
      if (!info) return;
      RTA.emit(`openUploadToast-${info.org_id}-${info.iss}`);
      triggerUploadToastOpen();
    }

    static concludeUploadItem(payload: any) {
      if (payload.status !== "success") return false;
      const newPayload: AdsProps = {
        id: payload.adId,
        src: payload.src,
        triggerLink: payload.triggerLink,
        active: payload.active,
        tags: payload.tags,
        name: payload.name,
        sizeMB: payload.sizeMB,
        isAdult: payload.isAdult,
        durationSec: payload.durationSec,
      };

      if (payload.percentageRate && payload.active) {
        newPayload.percentageRate = payload.percentageRate;
      }

      setAds((prev) => {
        // Idempotent with the create-flow refetch: never append an ad the list
        // already holds, so the socket path and the refetch cannot duplicate it.
        if (prev.some((ad) => ad.id === newPayload.id)) return prev;
        const updated = [...prev, newPayload];
        return updated.sort((a, b) => {
          const x = a.percentageRate ?? -Infinity;
          const y = b.percentageRate ?? -Infinity;
          return y - x;
        });
      });
    }
  }

  class handleMenu {
    static open(event: React.MouseEvent<HTMLElement>) {
      const bruteId = event.currentTarget.id;
      setAnchorEl(event.currentTarget);
      candidateAdId.current = bruteId;
    }

    static close() {
      setAnchorEl(null);
    }
  }

  class APIEvents {
    static async getBudgetLimit() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      try {
        const res = await adsAPI.get("/radio-budget", { headers });
        setRadioBudgetLimit(res.data.radioBudgetLimit ?? 0);
        setHasRadioBudgetLimit(res.data.radioBudgetLimit !== undefined);
        setRadioBudgetUsed(res.data.radioBudgetConsumed);
        setRadioPacingState(res.data.pacingState);
        setTimeout(() => setLoadingRadioBudget(false), 1000);
      } catch (error: any) {
        console.error(error);
      }
    }

    // Purely informational, so it must never gate the budget skeleton above
    // (that is why it is not nested inside getBudgetLimit's try block
    // anymore) and it is fetched once on mount by its own effect, not on
    // every one of getBudgetLimit's six call sites (debounced search, ad
    // create, upload settle): the market index changes once a month.
    static async getMarketIndex() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      try {
        const idx = await adsAPI.get<MarketIndexResp>("/market-index", {
          headers,
        });
        if (isMarketIndexFeature(idx.data?.radio)) {
          setRadioMarketIndex(idx.data.radio);
        } else {
          // The request succeeded, so this is not the expected "not deployed
          // yet" 404: the payload does not match what this module expects (a
          // renamed field, or the old nested {effective: {...}} wording). Log
          // it so a real contract drift is diagnosable once Plan 2 ships,
          // instead of degrading identically to "endpoint absent".
          console.error("Unexpected /ads/market-index payload shape for radio", idx.data?.radio);
          setRadioMarketIndex(null);
        }
      } catch (error: any) {
        // The index endpoint ships with the ads service release; without it the
        // block is simply not shown. Absence of data is "não medido", never a fake value.
        // Still log: a real outage or auth failure here must not be indistinguishable
        // from the expected "not deployed yet" 404, so only the 404 itself stays quiet.
        if (error?.response?.status !== 404) {
          console.error(error);
        }
        setRadioMarketIndex(null);
      }
    }

    static async listRadioAds() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const currAds: AdsProps[] = [];
      const size = 500;
      let query = `/radio`;
      if (search.trim()) query += `?search=${search.trim()}`;
      for (let page = 0; ; page++) {
        try {
          const res = await adsAPI.get(query, {
            headers: headers,
            params: { page, size, bandwidthMbps },
          });
          if (!res.data) {
            setAds(currAds);
            return;
          }
          const radioAds = res.data as AdsProps[];
          currAds.push(...radioAds);
          if (radioAds.length < size) {
            setAds(
              currAds.sort((a, b) => {
                const x = a.percentageRate ?? -Infinity;
                const y = b.percentageRate ?? -Infinity;
                return y - x;
              }),
            );
            return;
          }
        } catch (err: any) {
          console.error(err);
          return;
        }
      }
    }

    static async deleteRadioAd() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      try {
        await adsAPI.delete(`/radio/${candidateAdId.current}`, { headers: headers });
        setAds(ads.filter((ad) => ad.id !== candidateAdId.current));
        setBannerFeedbackType("success");
        setBannerFeedbackMessage(`Anúncio excluído com sucesso`);
        setBannerFeedbackIsOpen(true);
        handleMenu.close();
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackType("error");
        setBannerFeedbackIsOpen(true);
        setBannerFeedbackMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível excluir o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        candidateAdId.current = "";
      }
    }

    static async defineRadioLimitBudget(val: number | undefined) {
      if (val !== undefined && val <= 0) {
        setBannerFeedbackType("error");
        setBannerFeedbackMessage("Insira um valor positivo para definir um limite de orçamento");
        setBannerFeedbackIsOpen(true);
        return;
      }

      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const body: { radioBudgetLimit?: number } = {};
      if (val) {
        body.radioBudgetLimit = val;
      }

      try {
        await adsAPI.put("/radio-budget", body, { headers });
        setRadioBudgetLimit(val ?? 0);
        setBannerFeedbackType("success");
        setBannerFeedbackMessage("Limite de orçamento definido com sucesso");
      } catch (error: any) {
        console.error(error);
        setBannerFeedbackType("error");
        setBannerFeedbackMessage(
          getUserFacingError(error, {
            context: "budget",
            fallback:
              "Não foi possível salvar o limite de orçamento. Tente novamente em instantes.",
          }),
        );
      } finally {
        setBannerFeedbackIsOpen(true);
      }
    }
  }

  React.useEffect(() => {
    RTA.connect();
    let cleanup = () => {};
    let isActive = true;
    sessionInfo()
      .then((info) => {
        if (!isActive || !info) return false;
        const receiveEvent = `receiveNewUploadItem-${info.org_id}`;
        const concludeEvent = `concludeUploadItem-${info.org_id}`;

        RTA.on(receiveEvent, SocketEvents.receiveNewUploadItem);
        RTA.on(concludeEvent, SocketEvents.concludeUploadItem);

        cleanup = () => {
          RTA.off(receiveEvent, SocketEvents.receiveNewUploadItem);
          RTA.off(concludeEvent, SocketEvents.concludeUploadItem);
        };
      })
      .catch((err) => {
        console.error("Error retrieving session info:", err);
      });
    return () => {
      isActive = false;
      cleanup();
    };
  }, []);

  React.useEffect(() => {
    APIEvents.listRadioAds();
    APIEvents.getBudgetLimit();
    setPlay({ playing: false, id: "" });
  }, [search, activeFilter]);

  React.useEffect(() => {
    const refreshSettledRadio = (event: Event) => {
      const detail = (event as CustomEvent<{ feature?: string }>).detail;
      if (detail?.feature !== "radio") return;
      void APIEvents.listRadioAds();
      void APIEvents.getBudgetLimit();
    };
    window.addEventListener(AD_UPLOAD_SETTLED_EVENT, refreshSettledRadio);
    return () => window.removeEventListener(AD_UPLOAD_SETTLED_EVENT, refreshSettledRadio);
  }, []);

  // Fetched once on mount: the market index changes once a month, so it
  // does not belong on getBudgetLimit's [search, activeFilter] / upload
  // settled triggers above.
  React.useEffect(() => {
    APIEvents.getMarketIndex();
  }, []);

  React.useEffect(() => {
    if (!play.playing) return;
    const ad = ads.find((ad) => ad.id === play.id);
    if (!ad) return;

    const element = document.getElementById("radioAdSourcePlaying");
    if (!element) return;

    const adChip = element?.parentElement?.parentElement;
    if (!adChip) return;

    const audio = new Audio(ad.src);
    audio.play();

    let secondPast = 0;
    const interval = setInterval(() => {
      const percentage = (secondPast / (ad.durationSec * 1000)) * 100;
      adChip.style.backgroundImage =
        "linear-gradient(90deg, var(--brand-a5) " +
        percentage +
        "%, var(--brand-a2) " +
        percentage +
        "%)";
      secondPast += 50;
      if (audio.ended) {
        adChip.removeAttribute("style");
        setPlay({ playing: false, id: "" });
        clearInterval(interval);
      }
    }, 50);

    return () => {
      adChip.removeAttribute("style");
      clearInterval(interval);
      audio.pause();
    };
  }, [play]);

  class Details {
    static config() {
      setDetailState("edit");
      setAnchorEl(null);
    }

    static close() {
      setDetailState(undefined);
      handleMenu.close();
    }
  }

  const RadioDetails = () => {
    const chosedAd =
      detailState === "edit" ? ads.find((ad) => ad.id === candidateAdId.current) : undefined;
    const [selectFile, setSelectFile] = React.useState<File>();
    const [openFrequency, setOpenFrequency] = React.useState(
      chosedAd && chosedAd.percentageRate ? true : false,
    );
    const [active, setActive] = React.useState(chosedAd ? chosedAd.active : true);
    const [isAdult, setIsAdult] = React.useState(
      initialCreativeAdultFlag(undefined, orgIsOnlyForAdults),
    );
    const [frequencyValue, setFrequencyValue] = React.useState(
      chosedAd && chosedAd.percentageRate ? chosedAd.percentageRate : 60,
    );
    const [name, setName] = React.useState(chosedAd ? chosedAd.name : "");
    const [inputTags, setInputTags] = React.useState<string[]>(chosedAd ? chosedAd.tags : []);
    const [redirect, setRedirect] = React.useState(chosedAd ? chosedAd.triggerLink : "");
    const [duration, setDuration] = React.useState(chosedAd ? chosedAd.durationSec : 0);
    const [viewPrice, setViewPrice] = React.useState(0);
    const [accessPrice, setAccessPrice] = React.useState(0);
    const [loading, setLoading] = React.useState(false);

    const [bannerFeedbackDetailIsOpen, setBannerFeedbackDetailIsOpen] = React.useState(false);
    const [bannerFeedbackDetailType, setBannerFeedbackDetailType] = React.useState<
      "error" | "success" | "warning" | "info"
    >("error");
    const [bannerFeedbackDetailMessage, setBannerFeedbackDetailMessage] = React.useState("");

    async function createRadioAd() {
      if (!selectFile) return;
      if (!name) return;
      if (!redirect) return;
      if (!duration) return;

      const validationTable: { [key: string]: boolean } = {
        "O nome do anúncio não pode ter mais de 50 caracteres": name.trim().length <= 50,
        "O nome do anúncio não pode ter menos de 1 caractere": name.trim().length >= 1,
        "Já existe anúncio com esse nome. Tente um nome diferente": ads.find(
          (ad) => ad.name.toLowerCase() === name.trim().toLowerCase(),
        )
          ? false
          : true,
        "O link de redirecionamento não pode ter mais de 255 caracteres":
          redirect.trim().length <= 255,
        "O link de redirecionamento é inválido": isValidUrl(redirect.trim()),
        "Tem que ter no minimo 3 tags": inputTags.length >= 3,
        "Tem que ter no máximo 7 tags": inputTags.length <= 7,
        "A soma das frequências dos anúncios não pode ser maior que 100%": openFrequency
          ? getSumPercentageRateAds(ads) + frequencyValue <= 100
          : true,
      };

      for (const [message, isValid] of Object.entries(validationTable)) {
        if (!isValid) {
          setBannerFeedbackDetailType("error");
          setBannerFeedbackDetailMessage(message);
          setBannerFeedbackDetailIsOpen(true);
          return;
        }
      }

      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const mediaId = crypto.randomUUID();
      setLoading(true);
      setBannerFeedbackDetailType("info");
      setBannerFeedbackDetailIsOpen(true);
      setBannerFeedbackDetailMessage("Aplicando tratamento ao anúncio...");
      try {
        const payload: { [key: string]: any } = {
          name: name.trim(),
          redirect: redirect.trim(),
          active,
          tags: inputTags,
          isAdult: creativeAdultFlag(isAdult, orgIsOnlyForAdults),
        };

        if (openFrequency) {
          payload["percentageRate"] = frequencyValue;
        }

        const res = await adsAPI.post("/radio", payload, { headers: headers });
        const newId = res.data.id as string;
        if (!newId) {
          throw new Error("Resposta sem id do anúncio");
        }

        const ticketId = `radio-${newId}`;
        const { promise } = createTurboUpload({
          ticketId,
          file: selectFile,
          mediaId,
          mediaType: "audio",
          section: "radioAd",
          identifiers: { radioAdId: newId },
          getToken: () => Promise.resolve(localforage.getItem("JWT") as Promise<string>),
        });

        const result = await promise;
        if (!result.ok) {
          if (result.backlog) {
            // Backlog cap: a friendly "na fila" notice, never a red error.
            setBannerFeedbackDetailType("info");
            setBannerFeedbackDetailMessage(UPLOAD_BACKLOG_NOTICE);
            setBannerFeedbackDetailIsOpen(true);
            return;
          }
          console.error(result);
          setBannerFeedbackDetailType("error");
          setBannerFeedbackDetailMessage(
            getUserFacingError(result, {
              context: "upload",
              fallback: "Não foi possível enviar o áudio. Confira o arquivo e tente novamente.",
            }),
          );
          setBannerFeedbackDetailIsOpen(true);
          return;
        }
        setDetailState(undefined);
        // Refresh the list from the server so the new ad shows immediately.
        // The RTA concludeUploadItem socket event is a fragile secondary path,
        // so the create flow must not depend on it to render what it created.
        APIEvents.listRadioAds();
        APIEvents.getBudgetLimit();
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackDetailType("error");
        setBannerFeedbackDetailIsOpen(true);
        setBannerFeedbackDetailMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível criar o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        setLoading(false);
      }
    }

    async function editRadioAd() {
      if (!chosedAd) return;

      const validationTable: { [key: string]: boolean } = {
        "O nome do anúncio não pode ter mais de 50 caracteres": name.trim().length <= 50,
        "O nome do anúncio não pode ter menos de 1 caractere": name.trim().length >= 1,
        "Já existe anúncio com esse nome. Tente um nome diferente": ads.find(
          (ad) => ad.id !== chosedAd!.id && ad.name.toLowerCase() === name.trim().toLowerCase(),
        )
          ? false
          : true,
        "O link de redirecionamento não pode ter mais de 255 caracteres":
          redirect.trim().length <= 255,
        "O link de redirecionamento é inválido": isValidUrl(redirect.trim()),
        "Tem que ter no minimo 3 tags": inputTags.length >= 3,
        "Tem que ter no máximo 7 tags": inputTags.length <= 7,
        "A soma das frequências dos anúncios não pode ser maior que 100%": openFrequency
          ? calculateSumPercentageRateByTargetAdId(
              ads,
              chosedAd!.id,
              openFrequency ? frequencyValue : 0,
            ) <= 100
          : true,
      };

      for (const [message, isValid] of Object.entries(validationTable)) {
        if (!isValid) {
          setBannerFeedbackDetailType("error");
          setBannerFeedbackDetailMessage(message);
          setBannerFeedbackDetailIsOpen(true);
          return;
        }
      }

      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const payload: { [key: string]: any } = {
        id: candidateAdId.current,
        name: name.trim(),
        active,
        redirect: redirect.trim(),
        tags: inputTags,
      };

      if (openFrequency && active) {
        payload["percentageRate"] = frequencyValue;
      }

      setLoading(true);
      try {
        await adsAPI.patch("/radio", payload, { headers: headers });
        setAds((prev) => {
          const updated = prev.map((ad) => {
            if (ad.id === candidateAdId.current) {
              ad.name = name.trim();
              ad.triggerLink = redirect;
              ad.active = active;
              ad.tags = inputTags;
              if (openFrequency) {
                if (active) {
                  ad.percentageRate = frequencyValue;
                } else {
                  ad.percentageRate = undefined;
                }
              }
            }
            return ad;
          });

          return updated.sort((a, b) => {
            const x = a.percentageRate ?? -Infinity;
            const y = b.percentageRate ?? -Infinity;
            return y - x;
          });
        });
        setBannerFeedbackType("success");
        setBannerFeedbackMessage(`Anúncio '${chosedAd?.name}' editado com sucesso`);
        setBannerFeedbackIsOpen(true);
        setDetailState(undefined);
        candidateAdId.current = "";
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackDetailType("error");
        setBannerFeedbackDetailIsOpen(true);
        setBannerFeedbackDetailMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível salvar o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        setLoading(false);
      }
    }

    function formatSeconds(seconds: number) {
      const minutes = Math.floor(seconds / 60);
      const sec = Math.floor(seconds % 60);
      return `${minutes}:${sec}`;
    }

    function defineAdsPrice(duration: number, size: number) {
      localforage.getItem("JWT").then(async (JWT) => {
        const p = new adsPrice(size, duration, "radio", JWT as string);
        const { view, access } = await p.price();
        setDuration(duration);
        setViewPrice(Number(view.toFixed(2)));
        setAccessPrice(Number(access.toFixed(2)));
      });
    }

    function checkIfDataCannotBeEdit(): boolean {
      if (!chosedAd) return true;
      if (!redirect) return true;
      if (inputTags.length < 3) return true;
      if (inputTags.length > 7) return true;
      if (openFrequency && frequencyValue <= 0) return true;
      if (
        openFrequency &&
        calculateSumPercentageRateByTargetAdId(
          ads,
          chosedAd.id,
          openFrequency ? frequencyValue : 0,
        ) > 100
      ) {
        return true;
      }

      const sameRedirect = redirect.trim() === chosedAd.triggerLink;
      if (!sameRedirect) return false;

      const sameActive = active === chosedAd.active;
      if (!sameActive) return false;

      const sameFrequency = (chosedAd.percentageRate ?? 0) === (openFrequency ? frequencyValue : 0);
      if (!sameFrequency) return false;

      const sameTags = JSON.stringify(inputTags.sort()) === JSON.stringify(chosedAd.tags.sort());
      if (!sameTags) return false;

      return true;
    }

    async function selectRadioCreative(event: React.ChangeEvent<HTMLInputElement>) {
      const input = event.currentTarget;
      const file = input.files?.[0];
      input.value = "";
      if (!file) return;

      const inspection = await inspectCreativeFile(file, "audio");
      if (!inspection.valid) {
        setSelectFile(undefined);
        setDuration(0);
        setBannerFeedbackDetailType("error");
        setBannerFeedbackDetailMessage(inspection.message ?? "Selecione um áudio válido.");
        setBannerFeedbackDetailIsOpen(true);
        return;
      }

      setSelectFile(file);
      defineAdsPrice(inspection.duration, file.size);
    }

    React.useEffect(() => {
      if (detailState !== "edit") return;
      if (!chosedAd) return;
      defineAdsPrice(chosedAd.durationSec, chosedAd.sizeMB);
    }, [detailState]);

    if (detailState === "create") {
      return (
        <FloatContainer close={() => setDetailState(undefined)}>
          <BannerFeedback
            type={bannerFeedbackDetailType}
            open={bannerFeedbackDetailIsOpen}
            message={bannerFeedbackDetailMessage}
            callback={() => {
              setBannerFeedbackDetailIsOpen(false);
              candidateAdId.current = "";
            }}
            sx={{
              width: "100%",
            }}
          />
          <div className="formAd">
            <label htmlFor="fileRadioAd">
              <input
                type="file"
                id="fileRadioAd"
                accept="audio/*"
                className="inputAd"
                onChange={selectRadioCreative}
                hidden
              />

              {selectFile ? (
                <div className="selectedFileAd">
                  <div className="selectedFileAdContainer">
                    <AudiotrackTwoToneIcon />
                    <span className="fileAdName">{selectFile.name}</span>
                  </div>
                  <InfoPopup
                    position="sw"
                    id="fileAdDetailsRadio"
                    classNameBox="fileAdDetailsBoxContainer"
                    withArrow
                    triggerElement={
                      <div className="fileAdDetails">
                        <FontAwesomeIcon icon={faCircleInfo} />
                      </div>
                    }
                  >
                    <div className="fileAdDetailBox">
                      <span className="fileAdDetailsTopic">
                        Duração:{" "}
                        <span className="fileAdDetailsResult">{formatSeconds(duration)}</span>
                      </span>
                      <span className="fileAdDetailsTopic">
                        Preço por view: <span className="fileAdDetailsResult">R${viewPrice}</span>
                      </span>
                      <span className="fileAdDetailsTopic">
                        Preço por click:{" "}
                        <span className="fileAdDetailsResult">R${accessPrice}</span>
                      </span>
                    </div>
                  </InfoPopup>
                </div>
              ) : (
                <div className="selectFileAd">
                  <AddIcon />
                  <span>Selecionar arquivo</span>
                </div>
              )}
            </label>
            <input
              type="text"
              placeholder="Nome"
              id="nameAd"
              className="inputAd"
              maxLength={50}
              onInput={(e) => setName((e.target as HTMLInputElement).value)}
              defaultValue={name}
            />
            <input
              type="text"
              placeholder="Link de redirecionamento"
              id="redirectAd"
              className="inputAd"
              maxLength={255}
              onInput={(e) => setRedirect((e.target as HTMLInputElement).value)}
              defaultValue={redirect}
            />
            <FormGroup>
              <FormControlLabel
                className="switchAd"
                control={
                  <Switch color="warning" onChange={() => setActive(!active)} checked={active} />
                }
                label="Ativo para circulação"
              />
              {!orgIsOnlyForAdults && (
                <FormControlLabel
                  className="switchAd"
                  control={
                    <Switch
                      color="warning"
                      onChange={() => setIsAdult(!isAdult)}
                      checked={isAdult}
                    />
                  }
                  label="Anúncio para adultos"
                />
              )}
              {active && (
                <div className="frequencyAdContainer">
                  <FormControlLabel
                    className="switchAd"
                    control={
                      <Switch
                        color="warning"
                        onChange={() => setOpenFrequency(!openFrequency)}
                        checked={openFrequency}
                      />
                    }
                    label="Personalizar frequência dos anúncios"
                  />
                  <InfoPopup
                    position={"nw"}
                    id="infoFrequencyRadioAd"
                    classNameBox="infoFrequencyAdBoxContainer"
                    triggerElement={
                      <FontAwesomeIcon icon={faCircleInfo} className="infoIconFrequencyAd" />
                    }
                  >
                    <span>
                      Definindo a frequência, esse anúncio será exibido apenas na porcentagem
                      definida por você. Portanto não se deve colocar um valor muito alto se já
                      houver outros anúncios com frequência personalizada, para não ultrapassar 100%
                      de exibição.
                    </span>
                  </InfoPopup>
                </div>
              )}
            </FormGroup>
            {openFrequency && active && (
              <Stack direction="row" spacing={2} sx={{ alignItems: "center", mb: 1 }}>
                <span>0%</span>
                <Slider
                  color="warning"
                  step={1}
                  min={0}
                  max={100}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `${value}%`}
                  value={frequencyValue}
                  onChange={(_, value) => setFrequencyValue(value as number)}
                  aria-label="frequencyRadioAd"
                />
                <span>100%</span>
              </Stack>
            )}
            <InputTags
              id="inputTagsRadioCreate"
              minTags={3}
              onChange={(tags: string[]) => setInputTags(tags)}
              onError={(error: string) => {
                setBannerFeedbackDetailType("error");
                setBannerFeedbackDetailMessage(error);
                setBannerFeedbackDetailIsOpen(true);
              }}
            />
            <Button
              type="success"
              callback={createRadioAd}
              icon={<FontAwesomeIcon icon={faPaperPlane} />}
              iconSlot="end"
              expand
              disabled={
                !selectFile ||
                !name ||
                !redirect ||
                inputTags.length < 3 ||
                inputTags.length > 7 ||
                (openFrequency && frequencyValue <= 0) ||
                (openFrequency && getSumPercentageRateAds(ads) + frequencyValue > 100)
              }
              loading={{ state: loading, text: "Criando..." }}
            >
              Criar Anúncio
            </Button>
          </div>
        </FloatContainer>
      );
    }

    if (detailState === "edit") {
      if (!chosedAd) return <></>;
      return (
        <FloatContainer close={() => setDetailState(undefined)}>
          <BannerFeedback
            type={bannerFeedbackDetailType}
            open={bannerFeedbackDetailIsOpen}
            message={bannerFeedbackDetailMessage}
            callback={() => setBannerFeedbackDetailIsOpen(false)}
            sx={{
              width: "100%",
            }}
          />
          <div className="formAd">
            <div className="fileAdAlreadyExists">
              <div className="selectedFileAdContainer">
                <AudiotrackTwoToneIcon />
                <span className="fileAdName">{chosedAd.name}</span>
              </div>
              <InfoPopup
                position="sw"
                id="fileAdDetailsRadio"
                classNameBox="fileAdDetailsBoxContainer"
                withArrow
                triggerElement={
                  <div className="fileAdDetails">
                    <FontAwesomeIcon icon={faCircleInfo} />
                  </div>
                }
              >
                <div className="fileAdDetailBox">
                  <span className="fileAdDetailsTopic">
                    Duração:{" "}
                    <span className="fileAdDetailsResult">
                      {formatSeconds(chosedAd.durationSec)}
                    </span>
                  </span>
                  <span className="fileAdDetailsTopic">
                    Preço por view: <span className="fileAdDetailsResult">R${viewPrice}</span>
                  </span>
                  <span className="fileAdDetailsTopic">
                    Preço por click: <span className="fileAdDetailsResult">R${accessPrice}</span>
                  </span>
                </div>
              </InfoPopup>
            </div>
            <input
              type="text"
              placeholder="Nome"
              id="nameAd"
              className="inputAd"
              maxLength={50}
              onInput={(e) => setName((e.target as HTMLInputElement).value)}
              defaultValue={name}
            />
            <input
              type="text"
              placeholder="Link de redirecionamento"
              id="redirectAd"
              className="inputAd"
              maxLength={255}
              onInput={(e) => setRedirect((e.target as HTMLInputElement).value)}
              defaultValue={redirect}
            />
            <FormGroup>
              <FormControlLabel
                className="switchAd"
                control={
                  <Switch color="warning" onChange={() => setActive(!active)} checked={active} />
                }
                label="Ativo para circulação"
              />
              {active && (
                <div className="frequencyAdContainer">
                  <FormControlLabel
                    className="switchAd"
                    control={
                      <Switch
                        color="warning"
                        onChange={() => setOpenFrequency(!openFrequency)}
                        checked={openFrequency}
                      />
                    }
                    label="Personalizar frequência dos anúncios"
                  />
                  <InfoPopup
                    position={"nw"}
                    id="infoFrequencyRadioAd"
                    classNameBox="infoFrequencyAdBoxContainer"
                    triggerElement={
                      <FontAwesomeIcon icon={faCircleInfo} className="infoIconFrequencyAd" />
                    }
                  >
                    <span>
                      Definindo a frequência, esse anúncio será exibido apenas na porcentagem
                      definida por você. Portanto não se deve colocar um valor muito alto se já
                      houver outros anúncios com frequência personalizada, para não ultrapassar 100%
                      de exibição.
                    </span>
                  </InfoPopup>
                </div>
              )}
            </FormGroup>
            {openFrequency && active && (
              <Stack direction="row" spacing={2} sx={{ alignItems: "center", mb: 1 }}>
                <span>0%</span>
                <Slider
                  color="warning"
                  step={1}
                  min={0}
                  max={100}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `${value}%`}
                  value={frequencyValue}
                  onChange={(_, value) => setFrequencyValue(value as number)}
                  aria-label="frequencyRadioAd"
                />
                <span>100%</span>
              </Stack>
            )}
            <InputTags
              id="inputTagsRadioEdit"
              minTags={3}
              initialValue={inputTags}
              onChange={(tags: string[]) => setInputTags(tags)}
              onError={(error: string) => {
                setBannerFeedbackDetailType("error");
                setBannerFeedbackDetailMessage(error);
                setBannerFeedbackDetailIsOpen(true);
              }}
            />
            <Button
              type="success"
              callback={editRadioAd}
              icon={<FontAwesomeIcon icon={faPaperPlane} />}
              iconSlot="end"
              expand
              disabled={checkIfDataCannotBeEdit()}
              loading={{ state: loading, text: "Editando..." }}
            >
              Editar Anúncio
            </Button>
          </div>
        </FloatContainer>
      );
    }

    return <></>;
  };

  async function triggerSearchTime(e: React.FormEvent<HTMLInputElement>) {
    if (bounceTimeNodeRef.current) {
      clearTimeout(bounceTimeNodeRef.current);
    }

    bounceTimeNodeRef.current = setTimeout(() => {
      setSearch((e.target as HTMLInputElement).value);
    }, numBounceTimeRef.current);
  }

  async function deleteRadioLimitBudget(onChangeVal: boolean) {
    if (onChangeVal) return false;
    if (radioBudgetLimit <= 0) return false;
    APIEvents.defineRadioLimitBudget(undefined);
  }

  const RadioBudgetLimit: JSX.Element = React.useMemo(() => {
    return (
      <>
        {/* Cam 3 Task 1: data-testid hooks for Playwright spec
            (e2e/financial/). Selector policy: data-testid only. */}
        <div className="featureBudgetConsumedContainer" data-testid="campaign-budget-radio">
          <span className="featureBudgetTitle">Gasto Atual:</span>
          <span className="featureBudgetConsumedValue" data-testid="campaign-budget-spent-radio">
            {formatCurrencyBRL(radioBudgetUsed)}
          </span>
        </div>
        <FormControlLabel
          className="switchAd"
          control={
            <Switch
              color="warning"
              onChange={() => {
                setHasRadioBudgetLimit(!hasRadioBudgetLimit);
                deleteRadioLimitBudget(!hasRadioBudgetLimit);
              }}
              checked={hasRadioBudgetLimit}
            />
          }
          label="Definir limite de orçamento para anúncios de rádio"
        />
        {hasRadioBudgetLimit && (
          <div className="featureBudgetLimit">
            <NumberField
              id="searchRadio"
              class="budgetLimitAd"
              icon={<AttachMoneyRoundedIcon />}
              min={0}
              value={radioBudgetLimit}
              onInput={(value) =>
                setRadioBudgetLimit(Number((value.target as HTMLInputElement).value))
              }
            />
            <button
              className="budgetLimitAdButton"
              style={radioBudgetLimit > 0 ? { opacity: 1, right: "-40px", zIndex: 1 } : {}}
              onClick={() => APIEvents.defineRadioLimitBudget(radioBudgetLimit)}
            >
              <ArrowForwardRoundedIcon className="budgetLimitADButtonIcon" />
            </button>
            <Chip class="budgetLimitAdChip">
              <span>Limite de Gasto</span>
            </Chip>
          </div>
        )}
      </>
    );
  }, [radioBudgetLimit, radioBudgetUsed, hasRadioBudgetLimit]);

  return (
    <>
      <RadioDetails />
      <div className="adsPageContainer">
        <br />
        <Title title="Rádio" subtitle="Gerencie os anúncios de rádio" />
        <br />
        <BannerFeedback
          type={bannerFeedbackType}
          open={bannerFeedbackIsOpen}
          message={bannerFeedbackMessage}
          callback={() => setBannerFeedbackIsOpen(false)}
          sx={{
            width: "100%",
          }}
        />
        {loadingRadioBudget ? <LoadingAdsBudgetLimit /> : RadioBudgetLimit}
        {radioMarketIndex &&
          (() => {
            const view = buildMarketIndexView(radioMarketIndex, new Date());
            const pacing = pacingLabel(radioPacingState);
            return (
              <div className="marketIndexBlock" data-testid="market-index-radio">
                <span className="marketIndexTitle">{view.titleLabel}</span>
                <div className="marketIndexRow">
                  <span className="marketIndexLabel">Multiplicador</span>
                  <span className="marketIndexValue" data-testid="market-index-multiplier-radio">
                    {view.multiplierLabel}
                  </span>
                </div>
                <div className="marketIndexRow">
                  <span className="marketIndexLabel">Concorrência</span>
                  <span className="marketIndexValue">{view.contentionLabel}</span>
                </div>
                <div className="marketIndexRow">
                  <span className="marketIndexLabel">Preço por view</span>
                  <span className="marketIndexValue" data-testid="market-index-view-price-radio">
                    {view.viewPriceLabel}
                  </span>
                </div>
                <div className="marketIndexRow">
                  <span className="marketIndexLabel">Preço por clique</span>
                  <span className="marketIndexValue">{view.accessPriceLabel}</span>
                </div>
                {view.lockLabel && (
                  <span className="marketIndexLock" data-testid="market-index-lock-radio">
                    {view.lockLabel}
                  </span>
                )}
                {pacing && (
                  <span className="marketIndexPacing" data-testid="market-index-pacing-radio">
                    {pacing}
                  </span>
                )}
              </div>
            );
          })()}
        <hr className="featureDividerAds" />
        <div className="adsActionRow">
          <div className="featureOptionAds">
            {checkPermission(permissions.roomRadioAds, "view") && (
              <Button
                icon={<AddIcon />}
                iconSlot="start"
                type="brand"
                class="addAds"
                callback={() => setDetailState("create")}
              >
                Criar Anúncio
              </Button>
            )}
            <Select
              containerId="filterActiveRadio"
              idBox="filterActiveRadioBox"
              classNameBox="filterActiveAdBox"
              className="filterActiveAd"
              label="Rádio"
              options={["Ativo", "Inativo"]}
              optionsValues={["active", "inactive"]}
              iconArrow={<ChevronDownIcon />}
              selectValue={(value) => setActiveFilter(value === "active" ? true : false)}
              defaultValue={activeFilter ? "active" : "inactive"}
            />
          </div>
          <TextField
            id="searchRadio"
            class="searchAd"
            placeholder="Procurar"
            icon={<SearchRoundedIcon />}
            onInput={triggerSearchTime}
            clear
          />
        </div>
        <div className="adsList">
          {ads.map(
            (ad) =>
              ad.active === activeFilter && (
                <React.Fragment key={ad.id}>
                  <Chip class="adChip" k={ad.id} id={ad.id} callback={handleMenu.open}>
                    <>
                      <div className="adRadioContent">
                        {play.playing && play.id === ad.id ? (
                          <div
                            id="radioAdSourcePlaying"
                            className="radioAdSourceBtn"
                            onClick={() => setPlay({ playing: false, id: "" })}
                          >
                            <PauseRounded />
                          </div>
                        ) : (
                          <div
                            className="radioAdSourceBtn"
                            onClick={() => setPlay({ playing: true, id: ad.id })}
                          >
                            <PlayArrowRounded />
                          </div>
                        )}
                        <span className="adNameItem">{ad.name}</span>
                      </div>
                      {ad.percentageRate && ad.percentageRate > 0 && (
                        <div className="adPercentageContent">
                          <span className="adPercentageItem">{ad.percentageRate}%</span>
                        </div>
                      )}
                    </>
                  </Chip>
                  {(checkPermission(permissions.roomRadioAds, "edit") ||
                    checkPermission(permissions.roomRadioAds, "delete")) && (
                    <Menu
                      id="radioAdMenu"
                      anchorEl={anchorEl}
                      open={openMenu}
                      onClose={handleMenu.close}
                      sx={menuSX}
                    >
                      {checkPermission(permissions.roomRadioAds, "edit") && (
                        <MenuItem className="colRoleMenu" onClick={Details.config}>
                          <FontAwesomeIcon icon={faCog} fixedWidth />
                          <span>Configurações</span>
                        </MenuItem>
                      )}
                      {checkPermission(permissions.roomRadioAds, "delete") && (
                        <MenuItem className="colRoleMenu" onClick={APIEvents.deleteRadioAd}>
                          <FontAwesomeIcon icon={faClose} fixedWidth />
                          <span>Excluir</span>
                        </MenuItem>
                      )}
                    </Menu>
                  )}
                </React.Fragment>
              ),
          )}
        </div>
      </div>
    </>
  );
}

export function TV() {
  const { orgIsOnlyForAdults } = useUser();
  const [detailState, setDetailState] = React.useState<"create" | "edit">();
  const [activeFilter, setActiveFilter] = React.useState(true);
  const [play, setPlay] = React.useState<PlayState>({ playing: false, id: "" });
  const [ads, setAds] = React.useState<AdsProps[]>([]);
  const [search, setSearch] = React.useState("");
  const [loadingTVBudget, setLoadingTVBudget] = React.useState(true);
  const [tvBudgetLimit, setTVBudgetLimit] = React.useState<number>(0);
  const [tvBudgetUsed, setTVBudgetUsed] = React.useState<number>(0);
  const [hasTVBudgetLimit, setHasTVBudgetLimit] = React.useState<boolean>(false);
  const [tvMarketIndex, setTVMarketIndex] = React.useState<MarketIndexFeature | null>(null);
  const [tvPacingState, setTVPacingState] = React.useState<PacingState | undefined>(undefined);
  const [bandwidthMbps] = React.useState(() => getBandwidthMbps());

  const [bannerFeedbackIsOpen, setBannerFeedbackIsOpen] = React.useState(false);
  const [bannerFeedbackType, setBannerFeedbackType] = React.useState<
    "error" | "success" | "warning" | "info"
  >("error");
  const [bannerFeedbackMessage, setBannerFeedbackMessage] = React.useState("");

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const candidateAdId = React.useRef<string>("");
  const bounceTimeNodeRef = React.useRef<NodeJS.Timeout | null>(null);
  const numBounceTimeRef = React.useRef<number>(300);
  const { permissions } = usePermissions();

  class SocketEvents {
    static async receiveNewUploadItem() {
      const info = await sessionInfo();
      if (!info) return;
      RTA.emit(`openUploadToast-${info.org_id}-${info.iss}`);
      triggerUploadToastOpen();
    }

    static concludeUploadItem(payload: any) {
      if (payload.status !== "success") return false;
      const newPayload: AdsProps = {
        id: payload.adId,
        src: payload.src,
        triggerLink: payload.triggerLink,
        active: payload.active,
        tags: payload.tags,
        name: payload.name,
        sizeMB: payload.sizeMB,
        isAdult: payload.isAdult,
        durationSec: payload.durationSec,
      };

      if (payload.percentageRate && payload.active) {
        newPayload.percentageRate = payload.percentageRate;
      }

      setAds((prev) => {
        // Idempotent with the create-flow refetch: never append an ad the list
        // already holds, so the socket path and the refetch cannot duplicate it.
        if (prev.some((ad) => ad.id === newPayload.id)) return prev;
        const updated = [...prev, newPayload];
        return updated.sort((a, b) => {
          const x = a.percentageRate ?? -Infinity;
          const y = b.percentageRate ?? -Infinity;
          return y - x;
        });
      });
    }
  }

  class handleMenu {
    static open(event: React.MouseEvent<HTMLElement>) {
      const bruteId = event.currentTarget.id;
      setAnchorEl(event.currentTarget);
      candidateAdId.current = bruteId;
    }

    static close() {
      setAnchorEl(null);
    }
  }

  class APIEvents {
    static async getBudgetLimit() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      try {
        const res = await adsAPI.get("/tv-budget", { headers });
        setTVBudgetLimit(res.data.tvBudgetLimit ?? 0);
        setHasTVBudgetLimit(res.data.tvBudgetLimit !== undefined);
        setTVBudgetUsed(res.data.tvBudgetConsumed);
        setTVPacingState(res.data.pacingState);
        setTimeout(() => setLoadingTVBudget(false), 1000);
      } catch (error: any) {
        console.error(error);
      }
    }

    // Purely informational, so it must never gate the budget skeleton above
    // (that is why it is not nested inside getBudgetLimit's try block
    // anymore) and it is fetched once on mount by its own effect, not on
    // every one of getBudgetLimit's six call sites (debounced search, ad
    // create, upload settle): the market index changes once a month.
    static async getMarketIndex() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      try {
        const idx = await adsAPI.get<MarketIndexResp>("/market-index", {
          headers,
        });
        if (isMarketIndexFeature(idx.data?.tv)) {
          setTVMarketIndex(idx.data.tv);
        } else {
          // The request succeeded, so this is not the expected "not deployed
          // yet" 404: the payload does not match what this module expects (a
          // renamed field, or the old nested {effective: {...}} wording). Log
          // it so a real contract drift is diagnosable once Plan 2 ships,
          // instead of degrading identically to "endpoint absent".
          console.error("Unexpected /ads/market-index payload shape for tv", idx.data?.tv);
          setTVMarketIndex(null);
        }
      } catch (error: any) {
        // The index endpoint ships with the ads service release; without it the
        // block is simply not shown. Absence of data is "não medido", never a fake value.
        // Still log: a real outage or auth failure here must not be indistinguishable
        // from the expected "not deployed yet" 404, so only the 404 itself stays quiet.
        if (error?.response?.status !== 404) {
          console.error(error);
        }
        setTVMarketIndex(null);
      }
    }

    static async listTVAds() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const currAds: AdsProps[] = [];
      const size = 500;
      let query = `/tv`;
      if (search.trim()) query += `?search=${search.trim()}`;
      for (let page = 0; ; page++) {
        try {
          const res = await adsAPI.get(query, {
            headers: headers,
            params: { page, size, bandwidthMbps },
          });
          if (!res.data) {
            setAds(currAds);
            return;
          }
          const tvAds = res.data as AdsProps[];
          currAds.push(...tvAds);
          if (tvAds.length < size) {
            setAds(
              currAds.sort((a, b) => {
                const x = a.percentageRate ?? -Infinity;
                const y = b.percentageRate ?? -Infinity;
                return y - x;
              }),
            );
            return;
          }
        } catch (err: any) {
          console.error(err);
          return;
        }
      }
    }

    static async deleteTVAd() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      try {
        await adsAPI.delete(`/tv/${candidateAdId.current}`, { headers: headers });
        setAds(ads.filter((ad) => ad.id !== candidateAdId.current));
        setBannerFeedbackType("success");
        setBannerFeedbackMessage(`Anúncio excluído com sucesso`);
        setBannerFeedbackIsOpen(true);
        handleMenu.close();
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackType("error");
        setBannerFeedbackIsOpen(true);
        setBannerFeedbackMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível excluir o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        candidateAdId.current = "";
      }
    }

    static async defineTVLimitBudget(val: number | undefined) {
      if (val !== undefined && val <= 0) {
        setBannerFeedbackType("error");
        setBannerFeedbackMessage("Insira um valor positivo para definir um limite de orçamento");
        setBannerFeedbackIsOpen(true);
        return;
      }

      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const body: { tvBudgetLimit?: number } = {};
      if (val) {
        body.tvBudgetLimit = val;
      }

      try {
        await adsAPI.put("/tv-budget", body, { headers });
        setTVBudgetLimit(val ?? 0);
        setBannerFeedbackType("success");
        setBannerFeedbackMessage("Limite de orçamento definido com sucesso");
      } catch (error: any) {
        console.error(error);
        setBannerFeedbackType("error");
        setBannerFeedbackMessage(
          getUserFacingError(error, {
            context: "budget",
            fallback:
              "Não foi possível salvar o limite de orçamento. Tente novamente em instantes.",
          }),
        );
      } finally {
        setBannerFeedbackIsOpen(true);
      }
    }
  }

  React.useEffect(() => {
    RTA.connect();
    let cleanup = () => {};
    let isActive = true;
    sessionInfo()
      .then((info) => {
        if (!isActive || !info) return false;
        const receiveEvent = `receiveNewUploadItem-${info.org_id}`;
        const concludeEvent = `concludeUploadItem-${info.org_id}`;

        RTA.on(receiveEvent, SocketEvents.receiveNewUploadItem);
        RTA.on(concludeEvent, SocketEvents.concludeUploadItem);

        cleanup = () => {
          RTA.off(receiveEvent, SocketEvents.receiveNewUploadItem);
          RTA.off(concludeEvent, SocketEvents.concludeUploadItem);
        };
      })
      .catch((err) => {
        console.error("Error retrieving session info:", err);
      });
    return () => {
      isActive = false;
      cleanup();
    };
  }, []);

  React.useEffect(() => {
    APIEvents.listTVAds();
    APIEvents.getBudgetLimit();
    setPlay({ playing: false, id: "" });
  }, [search, activeFilter]);

  React.useEffect(() => {
    const refreshSettledTV = (event: Event) => {
      const detail = (event as CustomEvent<{ feature?: string }>).detail;
      if (detail?.feature !== "tv") return;
      void APIEvents.listTVAds();
      void APIEvents.getBudgetLimit();
    };
    window.addEventListener(AD_UPLOAD_SETTLED_EVENT, refreshSettledTV);
    return () => window.removeEventListener(AD_UPLOAD_SETTLED_EVENT, refreshSettledTV);
  }, []);

  // Fetched once on mount: the market index changes once a month, so it
  // does not belong on getBudgetLimit's [search, activeFilter] / upload
  // settled triggers above.
  React.useEffect(() => {
    APIEvents.getMarketIndex();
  }, []);

  React.useEffect(() => {
    if (!play.playing) return;
    const ad = ads.find((ad) => ad.id === play.id);
    if (!ad) return;

    const element = document.getElementById("tvAdSourcePlaying") as HTMLVideoElement;
    if (!element) return;

    element.requestFullscreen();
    element.play();
    element.addEventListener("fullscreenchange", minimizeFullscreen);
    element.addEventListener("ended", exitVideo);
    return () => {
      element.removeEventListener("fullscreenchange", minimizeFullscreen);
      element.removeEventListener("ended", exitVideo);
    };
  }, [play]);

  class Details {
    static config() {
      setDetailState("edit");
      setAnchorEl(null);
    }

    static close() {
      setDetailState(undefined);
      handleMenu.close();
    }
  }

  const TVDetails = () => {
    const chosedAd =
      detailState === "edit" ? ads.find((ad) => ad.id === candidateAdId.current) : undefined;
    const [selectFile, setSelectFile] = React.useState<File>();
    const [openFrequency, setOpenFrequency] = React.useState(
      chosedAd && chosedAd.percentageRate ? true : false,
    );
    const [active, setActive] = React.useState(chosedAd ? chosedAd.active : true);
    const [isAdult, setIsAdult] = React.useState(
      initialCreativeAdultFlag(undefined, orgIsOnlyForAdults),
    );
    const [frequencyValue, setFrequencyValue] = React.useState(
      chosedAd && chosedAd.percentageRate ? chosedAd.percentageRate : 60,
    );
    const [name, setName] = React.useState(chosedAd ? chosedAd.name : "");
    const [inputTags, setInputTags] = React.useState<string[]>(chosedAd ? chosedAd.tags : []);
    const [redirect, setRedirect] = React.useState(chosedAd ? chosedAd.triggerLink : "");
    const [duration, setDuration] = React.useState(chosedAd ? chosedAd.durationSec : 0);
    const [viewPrice, setViewPrice] = React.useState(0);
    const [accessPrice, setAccessPrice] = React.useState(0);
    const [loading, setLoading] = React.useState(false);

    const [bannerFeedbackDetailIsOpen, setBannerFeedbackDetailIsOpen] = React.useState(false);
    const [bannerFeedbackDetailType, setBannerFeedbackDetailType] = React.useState<
      "error" | "success" | "warning" | "info"
    >("error");
    const [bannerFeedbackDetailMessage, setBannerFeedbackDetailMessage] = React.useState("");

    async function createTVAd() {
      if (!selectFile) return;
      if (!name) return;
      if (!redirect) return;
      if (!duration) return;

      const validationTable: { [key: string]: boolean } = {
        "O nome do anúncio não pode ter mais de 50 caracteres": name.trim().length <= 50,
        "O nome do anúncio não pode ter menos de 1 caractere": name.trim().length >= 1,
        "Já existe anúncio com esse nome. Tente um nome diferente": ads.find(
          (ad) => ad.name.toLowerCase() === name.trim().toLowerCase(),
        )
          ? false
          : true,
        "O link de redirecionamento não pode ter mais de 255 caracteres":
          redirect.trim().length <= 255,
        "O link de redirecionamento é inválido": isValidUrl(redirect.trim()),
        "Tem que ter no minimo 3 tags": inputTags.length >= 3,
        "Tem que ter no máximo 7 tags": inputTags.length <= 7,
        "A soma das frequências dos anúncios não pode ser maior que 100%": openFrequency
          ? getSumPercentageRateAds(ads) + frequencyValue <= 100
          : true,
      };

      for (const [message, isValid] of Object.entries(validationTable)) {
        if (!isValid) {
          setBannerFeedbackDetailType("error");
          setBannerFeedbackDetailMessage(message);
          setBannerFeedbackDetailIsOpen(true);
          return;
        }
      }

      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const mediaId = crypto.randomUUID();
      setLoading(true);
      setBannerFeedbackDetailType("info");
      setBannerFeedbackDetailIsOpen(true);
      setBannerFeedbackDetailMessage("Aplicando tratamento ao anúncio...");
      try {
        const payload: { [key: string]: any } = {
          name: name.trim(),
          redirect: redirect.trim(),
          active,
          tags: inputTags,
          isAdult: creativeAdultFlag(isAdult, orgIsOnlyForAdults),
        };

        if (openFrequency) {
          payload["percentageRate"] = frequencyValue;
        }

        const res = await adsAPI.post("/tv", payload, { headers: headers });
        const newId = res.data.id as string;
        if (!newId) {
          throw new Error("Resposta sem id do anúncio");
        }

        const ticketId = `tv-${newId}`;
        const { promise } = createTurboUpload({
          ticketId,
          file: selectFile,
          mediaId,
          mediaType: "video",
          section: "tvAd",
          identifiers: { tvAdId: newId },
          getToken: () => Promise.resolve(localforage.getItem("JWT") as Promise<string>),
        });

        const result = await promise;
        if (!result.ok) {
          if (result.backlog) {
            // Backlog cap: a friendly "na fila" notice, never a red error.
            setBannerFeedbackDetailType("info");
            setBannerFeedbackDetailMessage(UPLOAD_BACKLOG_NOTICE);
            setBannerFeedbackDetailIsOpen(true);
            return;
          }
          console.error(result);
          setBannerFeedbackDetailType("error");
          setBannerFeedbackDetailMessage(
            getUserFacingError(result, {
              context: "upload",
              fallback: "Não foi possível enviar o vídeo. Confira o arquivo e tente novamente.",
            }),
          );
          setBannerFeedbackDetailIsOpen(true);
          return;
        }
        setDetailState(undefined);
        // Refresh the list from the server so the new ad shows immediately.
        // The RTA concludeUploadItem socket event is a fragile secondary path,
        // so the create flow must not depend on it to render what it created.
        APIEvents.listTVAds();
        APIEvents.getBudgetLimit();
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackDetailType("error");
        setBannerFeedbackDetailIsOpen(true);
        setBannerFeedbackDetailMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível criar o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        setLoading(false);
      }
    }

    async function editTVAd() {
      if (!chosedAd) return;

      const validationTable: { [key: string]: boolean } = {
        "O nome do anúncio não pode ter mais de 50 caracteres": name.trim().length <= 50,
        "O nome do anúncio não pode ter menos de 1 caractere": name.trim().length >= 1,
        "Já existe anúncio com esse nome. Tente um nome diferente": ads.find(
          (ad) => ad.id !== chosedAd!.id && ad.name.toLowerCase() === name.trim().toLowerCase(),
        )
          ? false
          : true,
        "O link de redirecionamento não pode ter mais de 255 caracteres":
          redirect.trim().length <= 255,
        "O link de redirecionamento é inválido": isValidUrl(redirect.trim()),
        "Tem que ter no minimo 3 tags": inputTags.length >= 3,
        "Tem que ter no máximo 7 tags": inputTags.length <= 7,
        "A soma das frequências dos anúncios não pode ser maior que 100%": openFrequency
          ? calculateSumPercentageRateByTargetAdId(
              ads,
              chosedAd!.id,
              openFrequency ? frequencyValue : 0,
            ) <= 100
          : true,
      };

      for (const [message, isValid] of Object.entries(validationTable)) {
        if (!isValid) {
          setBannerFeedbackDetailType("error");
          setBannerFeedbackDetailMessage(message);
          setBannerFeedbackDetailIsOpen(true);
          return;
        }
      }

      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const payload: { [key: string]: any } = {
        id: candidateAdId.current,
        name: name.trim(),
        active,
        redirect: redirect.trim(),
        tags: inputTags,
      };

      if (openFrequency && active) {
        payload["percentageRate"] = frequencyValue;
      }

      setLoading(true);
      try {
        await adsAPI.patch("/tv", payload, { headers: headers });
        setAds((prev) => {
          const updated = prev.map((ad) => {
            if (ad.id === candidateAdId.current) {
              ad.name = name.trim();
              ad.triggerLink = redirect;
              ad.active = active;
              ad.tags = inputTags;
              if (openFrequency) {
                if (active) {
                  ad.percentageRate = frequencyValue;
                } else {
                  ad.percentageRate = undefined;
                }
              }
            }
            return ad;
          });

          return updated.sort((a, b) => {
            const x = a.percentageRate ?? -Infinity;
            const y = b.percentageRate ?? -Infinity;
            return y - x;
          });
        });
        setBannerFeedbackType("success");
        setBannerFeedbackMessage(`Anúncio '${chosedAd?.name}' editado com sucesso`);
        setBannerFeedbackIsOpen(true);
        setDetailState(undefined);
        candidateAdId.current = "";
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackDetailType("error");
        setBannerFeedbackDetailIsOpen(true);
        setBannerFeedbackDetailMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível salvar o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        setLoading(false);
      }
    }

    function formatSeconds(seconds: number) {
      const minutes = Math.floor(seconds / 60);
      const sec = Math.floor(seconds % 60);
      return `${minutes}:${sec}`;
    }

    function defineAdsPrice(duration: number, size: number) {
      localforage.getItem("JWT").then(async (JWT) => {
        const p = new adsPrice(size, duration, "tv", JWT as string);
        const { view, access } = await p.price();
        setDuration(duration);
        setViewPrice(Number(view.toFixed(2)));
        setAccessPrice(Number(access.toFixed(2)));
      });
    }

    function checkIfDataCannotBeEdit(): boolean {
      if (!chosedAd) return true;
      if (!redirect) return true;
      if (inputTags.length < 3) return true;
      if (inputTags.length > 7) return true;
      if (openFrequency && frequencyValue <= 0) return true;
      if (
        openFrequency &&
        calculateSumPercentageRateByTargetAdId(
          ads,
          chosedAd.id,
          openFrequency ? frequencyValue : 0,
        ) > 100
      ) {
        return true;
      }

      const sameRedirect = redirect.trim() === chosedAd.triggerLink;
      if (!sameRedirect) return false;

      const sameActive = active === chosedAd.active;
      if (!sameActive) return false;

      const sameFrequency = (chosedAd.percentageRate ?? 0) === (openFrequency ? frequencyValue : 0);
      if (!sameFrequency) return false;

      const sameTags = JSON.stringify(inputTags.sort()) === JSON.stringify(chosedAd.tags.sort());
      if (!sameTags) return false;

      return true;
    }

    async function selectTVCreative(event: React.ChangeEvent<HTMLInputElement>) {
      const input = event.currentTarget;
      const file = input.files?.[0];
      input.value = "";
      if (!file) return;

      const inspection = await inspectCreativeFile(file, "video");
      if (!inspection.valid) {
        setSelectFile(undefined);
        setDuration(0);
        setBannerFeedbackDetailType("error");
        setBannerFeedbackDetailMessage(inspection.message ?? "Selecione um vídeo válido.");
        setBannerFeedbackDetailIsOpen(true);
        return;
      }

      setSelectFile(file);
      defineAdsPrice(inspection.duration, file.size);
    }

    React.useEffect(() => {
      if (detailState !== "edit") return;
      if (!chosedAd) return;
      defineAdsPrice(chosedAd.durationSec, chosedAd.sizeMB);
    }, [detailState]);

    if (detailState === "create") {
      return (
        <FloatContainer close={() => setDetailState(undefined)}>
          <BannerFeedback
            type={bannerFeedbackDetailType}
            open={bannerFeedbackDetailIsOpen}
            message={bannerFeedbackDetailMessage}
            callback={() => {
              setBannerFeedbackDetailIsOpen(false);
              candidateAdId.current = "";
            }}
            sx={{
              width: "100%",
            }}
          />
          <div className="formAd">
            <label htmlFor="fileTVAd">
              <input
                type="file"
                id="fileTVAd"
                accept="video/*"
                className="inputAd"
                onChange={selectTVCreative}
                hidden
              />

              {selectFile ? (
                <div className="selectedFileAd">
                  <div className="selectedFileAdContainer">
                    <VideocamRounded />
                    <span className="fileAdName">{selectFile.name}</span>
                  </div>
                  <InfoPopup
                    position="sw"
                    id="fileAdDetailsTV"
                    classNameBox="fileAdDetailsBoxContainer"
                    withArrow
                    triggerElement={
                      <div className="fileAdDetails">
                        <FontAwesomeIcon icon={faCircleInfo} />
                      </div>
                    }
                  >
                    <div className="fileAdDetailBox">
                      <span className="fileAdDetailsTopic">
                        Duração:{" "}
                        <span className="fileAdDetailsResult">{formatSeconds(duration)}</span>
                      </span>
                      <span className="fileAdDetailsTopic">
                        Preço por view: <span className="fileAdDetailsResult">R${viewPrice}</span>
                      </span>
                      <span className="fileAdDetailsTopic">
                        Preço por click:{" "}
                        <span className="fileAdDetailsResult">R${accessPrice}</span>
                      </span>
                    </div>
                  </InfoPopup>
                </div>
              ) : (
                <div className="selectFileAd">
                  <AddIcon />
                  <span>Selecionar arquivo</span>
                </div>
              )}
            </label>
            <input
              type="text"
              placeholder="Nome"
              id="nameAd"
              className="inputAd"
              maxLength={50}
              onInput={(e) => setName((e.target as HTMLInputElement).value)}
              defaultValue={name}
            />
            <input
              type="text"
              placeholder="Link de redirecionamento"
              id="redirectAd"
              className="inputAd"
              maxLength={255}
              onInput={(e) => setRedirect((e.target as HTMLInputElement).value)}
              defaultValue={redirect}
            />
            <FormGroup>
              <FormControlLabel
                className="switchAd"
                control={
                  <Switch color="warning" onChange={() => setActive(!active)} checked={active} />
                }
                label="Ativo para circulação"
              />
              {!orgIsOnlyForAdults && (
                <FormControlLabel
                  className="switchAd"
                  control={
                    <Switch
                      color="warning"
                      onChange={() => setIsAdult(!isAdult)}
                      checked={isAdult}
                    />
                  }
                  label="Anúncio para adultos"
                />
              )}
              {active && (
                <div className="frequencyAdContainer">
                  <FormControlLabel
                    className="switchAd"
                    control={
                      <Switch
                        color="warning"
                        onChange={() => setOpenFrequency(!openFrequency)}
                        checked={openFrequency}
                      />
                    }
                    label="Personalizar frequência dos anúncios"
                  />
                  <InfoPopup
                    position={"nw"}
                    id="infoFrequencyTVAd"
                    classNameBox="infoFrequencyAdBoxContainer"
                    triggerElement={
                      <FontAwesomeIcon icon={faCircleInfo} className="infoIconFrequencyAd" />
                    }
                  >
                    <span>
                      Definindo a frequência, esse anúncio será exibido apenas na porcentagem
                      definida por você. Portanto não se deve colocar um valor muito alto se já
                      houver outros anúncios com frequência personalizada, para não ultrapassar 100%
                      de exibição.
                    </span>
                  </InfoPopup>
                </div>
              )}
            </FormGroup>
            {openFrequency && active && (
              <Stack direction="row" spacing={2} sx={{ alignItems: "center", mb: 1 }}>
                <span>0%</span>
                <Slider
                  color="warning"
                  step={1}
                  min={0}
                  max={100}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `${value}%`}
                  value={frequencyValue}
                  onChange={(_, value) => setFrequencyValue(value as number)}
                  aria-label="frequencyTVAd"
                />
                <span>100%</span>
              </Stack>
            )}
            <InputTags
              id="inputTagsTVCreate"
              minTags={3}
              onChange={(tags: string[]) => setInputTags(tags)}
              onError={(error: string) => {
                setBannerFeedbackDetailType("error");
                setBannerFeedbackDetailMessage(error);
                setBannerFeedbackDetailIsOpen(true);
              }}
            />
            <Button
              type="success"
              callback={createTVAd}
              icon={<FontAwesomeIcon icon={faPaperPlane} />}
              iconSlot="end"
              expand
              disabled={
                !selectFile ||
                !name ||
                !redirect ||
                inputTags.length < 3 ||
                inputTags.length > 7 ||
                (openFrequency && frequencyValue <= 0) ||
                (openFrequency && getSumPercentageRateAds(ads) + frequencyValue > 100)
              }
              loading={{ state: loading, text: "Criando..." }}
            >
              Criar Anúncio
            </Button>
          </div>
        </FloatContainer>
      );
    }

    if (detailState === "edit") {
      if (!chosedAd) return <></>;
      return (
        <FloatContainer close={() => setDetailState(undefined)}>
          <BannerFeedback
            type={bannerFeedbackDetailType}
            open={bannerFeedbackDetailIsOpen}
            message={bannerFeedbackDetailMessage}
            callback={() => setBannerFeedbackDetailIsOpen(false)}
            sx={{
              width: "100%",
            }}
          />
          <div className="formAd">
            <div className="fileAdAlreadyExists">
              <div className="selectedFileAdContainer">
                <AudiotrackTwoToneIcon />
                <span className="fileAdName">{chosedAd.name}</span>
              </div>
              <InfoPopup
                position="sw"
                id="fileAdDetailsTV"
                classNameBox="fileAdDetailsBoxContainer"
                withArrow
                triggerElement={
                  <div className="fileAdDetails">
                    <FontAwesomeIcon icon={faCircleInfo} />
                  </div>
                }
              >
                <div className="fileAdDetailBox">
                  <span className="fileAdDetailsTopic">
                    Duração:{" "}
                    <span className="fileAdDetailsResult">
                      {formatSeconds(chosedAd.durationSec)}
                    </span>
                  </span>
                  <span className="fileAdDetailsTopic">
                    Preço por view: <span className="fileAdDetailsResult">R${viewPrice}</span>
                  </span>
                  <span className="fileAdDetailsTopic">
                    Preço por click: <span className="fileAdDetailsResult">R${accessPrice}</span>
                  </span>
                </div>
              </InfoPopup>
            </div>
            <input
              type="text"
              placeholder="Nome"
              id="nameAd"
              className="inputAd"
              maxLength={50}
              onInput={(e) => setName((e.target as HTMLInputElement).value)}
              defaultValue={name}
            />
            <input
              type="text"
              placeholder="Link de redirecionamento"
              id="redirectAd"
              className="inputAd"
              maxLength={255}
              onInput={(e) => setRedirect((e.target as HTMLInputElement).value)}
              defaultValue={redirect}
            />
            <FormGroup>
              <FormControlLabel
                className="switchAd"
                control={
                  <Switch color="warning" onChange={() => setActive(!active)} checked={active} />
                }
                label="Ativo para circulação"
              />
              {active && (
                <div className="frequencyAdContainer">
                  <FormControlLabel
                    className="switchAd"
                    control={
                      <Switch
                        color="warning"
                        onChange={() => setOpenFrequency(!openFrequency)}
                        checked={openFrequency}
                      />
                    }
                    label="Personalizar frequência dos anúncios"
                  />
                  <InfoPopup
                    position={"nw"}
                    id="infoFrequencyTVAd"
                    classNameBox="infoFrequencyAdBoxContainer"
                    triggerElement={
                      <FontAwesomeIcon icon={faCircleInfo} className="infoIconFrequencyAd" />
                    }
                  >
                    <span>
                      Definindo a frequência, esse anúncio será exibido apenas na porcentagem
                      definida por você. Portanto não se deve colocar um valor muito alto se já
                      houver outros anúncios com frequência personalizada, para não ultrapassar 100%
                      de exibição.
                    </span>
                  </InfoPopup>
                </div>
              )}
            </FormGroup>
            {openFrequency && active && (
              <Stack direction="row" spacing={2} sx={{ alignItems: "center", mb: 1 }}>
                <span>0%</span>
                <Slider
                  color="warning"
                  step={1}
                  min={0}
                  max={100}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `${value}%`}
                  value={frequencyValue}
                  onChange={(_, value) => setFrequencyValue(value as number)}
                  aria-label="frequencyTVAd"
                />
                <span>100%</span>
              </Stack>
            )}
            <InputTags
              id="inputTagsTVEdit"
              minTags={3}
              initialValue={inputTags}
              onChange={(tags: string[]) => setInputTags(tags)}
              onError={(error: string) => {
                setBannerFeedbackDetailType("error");
                setBannerFeedbackDetailMessage(error);
                setBannerFeedbackDetailIsOpen(true);
              }}
            />
            <Button
              type="success"
              callback={editTVAd}
              icon={<FontAwesomeIcon icon={faPaperPlane} />}
              iconSlot="end"
              expand
              disabled={checkIfDataCannotBeEdit()}
              loading={{ state: loading, text: "Editando..." }}
            >
              Editar Anúncio
            </Button>
          </div>
        </FloatContainer>
      );
    }
  };

  function minimizeFullscreen() {
    const element = document.getElementById("tvAdSourcePlaying");
    if (!element) return;

    if (document.fullscreenElement) return;
    setPlay({ playing: false, id: "" });
  }

  function exitVideo() {
    setPlay({ playing: false, id: "" });
  }

  async function triggerSearchTime(e: React.FormEvent<HTMLInputElement>) {
    if (bounceTimeNodeRef.current) {
      clearTimeout(bounceTimeNodeRef.current);
    }

    bounceTimeNodeRef.current = setTimeout(() => {
      setSearch((e.target as HTMLInputElement).value);
    }, numBounceTimeRef.current);
  }

  async function deleteTVLimitBudget(onChangeVal: boolean) {
    if (onChangeVal) return false;
    if (tvBudgetLimit <= 0) return false;
    APIEvents.defineTVLimitBudget(undefined);
  }

  const TVBudgetLimit: JSX.Element = React.useMemo(() => {
    return (
      <>
        {/* Cam 3 Task 1: data-testid hooks for Playwright spec
            (e2e/financial/). Selector policy: data-testid only. */}
        <div className="featureBudgetConsumedContainer" data-testid="campaign-budget-tv">
          <span className="featureBudgetTitle">Gasto Atual:</span>
          <span className="featureBudgetConsumedValue" data-testid="campaign-budget-spent-tv">
            {formatCurrencyBRL(tvBudgetUsed)}
          </span>
        </div>
        <FormControlLabel
          className="switchAd"
          control={
            <Switch
              color="warning"
              onChange={() => {
                setHasTVBudgetLimit(!hasTVBudgetLimit);
                deleteTVLimitBudget(!hasTVBudgetLimit);
              }}
              checked={hasTVBudgetLimit}
            />
          }
          label="Definir limite de orçamento para anúncios de TV"
        />
        {hasTVBudgetLimit && (
          <div className="featureBudgetLimit">
            <NumberField
              id="searchTV"
              class="budgetLimitAd"
              icon={<AttachMoneyRoundedIcon />}
              min={0}
              value={tvBudgetLimit}
              onInput={(value) =>
                setTVBudgetLimit(Number((value.target as HTMLInputElement).value))
              }
            />
            <button
              className="budgetLimitAdButton"
              style={tvBudgetLimit > 0 ? { opacity: 1, right: "-40px", zIndex: 1 } : {}}
              onClick={() => APIEvents.defineTVLimitBudget(tvBudgetLimit)}
            >
              <ArrowForwardRoundedIcon className="budgetLimitADButtonIcon" />
            </button>
            <Chip class="budgetLimitAdChip">
              <span>Limite de Gasto</span>
            </Chip>
          </div>
        )}
      </>
    );
  }, [tvBudgetLimit, tvBudgetUsed, hasTVBudgetLimit]);

  return (
    <>
      {play.playing && (
        <video id="tvAdSourcePlaying" controls>
          <source src={ads.find((ad) => ad.id === play.id)?.src} type="video/mp4" />
        </video>
      )}
      <TVDetails />
      <div className="adsPageContainer">
        <br />
        <Title title="TV" subtitle="Gerencie os anúncios de TV" />
        <br />
        <BannerFeedback
          type={bannerFeedbackType}
          open={bannerFeedbackIsOpen}
          message={bannerFeedbackMessage}
          callback={() => setBannerFeedbackIsOpen(false)}
          sx={{
            width: "100%",
          }}
        />
        {loadingTVBudget ? <LoadingAdsBudgetLimit /> : TVBudgetLimit}
        {tvMarketIndex &&
          (() => {
            const view = buildMarketIndexView(tvMarketIndex, new Date());
            const pacing = pacingLabel(tvPacingState);
            return (
              <div className="marketIndexBlock" data-testid="market-index-tv">
                <span className="marketIndexTitle">{view.titleLabel}</span>
                <div className="marketIndexRow">
                  <span className="marketIndexLabel">Multiplicador</span>
                  <span className="marketIndexValue" data-testid="market-index-multiplier-tv">
                    {view.multiplierLabel}
                  </span>
                </div>
                <div className="marketIndexRow">
                  <span className="marketIndexLabel">Concorrência</span>
                  <span className="marketIndexValue">{view.contentionLabel}</span>
                </div>
                <div className="marketIndexRow">
                  <span className="marketIndexLabel">Preço por view</span>
                  <span className="marketIndexValue" data-testid="market-index-view-price-tv">
                    {view.viewPriceLabel}
                  </span>
                </div>
                <div className="marketIndexRow">
                  <span className="marketIndexLabel">Preço por clique</span>
                  <span className="marketIndexValue">{view.accessPriceLabel}</span>
                </div>
                {view.lockLabel && (
                  <span className="marketIndexLock" data-testid="market-index-lock-tv">
                    {view.lockLabel}
                  </span>
                )}
                {pacing && (
                  <span className="marketIndexPacing" data-testid="market-index-pacing-tv">
                    {pacing}
                  </span>
                )}
              </div>
            );
          })()}
        <hr className="featureDividerAds" />
        <div className="adsActionRow">
          <div className="featureOptionAds">
            {checkPermission(permissions.roomTvAds, "create") && (
              <Button
                icon={<AddIcon />}
                iconSlot="start"
                type="brand"
                class="addAds"
                callback={() => setDetailState("create")}
              >
                Criar Anúncio
              </Button>
            )}
            <Select
              containerId="filterActiveTV"
              idBox="filterActiveTVBox"
              classNameBox="filterActiveAdBox"
              className="filterActiveAd"
              label="TV"
              options={["Ativo", "Inativo"]}
              optionsValues={["active", "inactive"]}
              iconArrow={<ChevronDownIcon />}
              selectValue={(value) => setActiveFilter(value === "active" ? true : false)}
              defaultValue={activeFilter ? "active" : "inactive"}
            />
          </div>
          <TextField
            id="searchTV"
            class="searchAd"
            placeholder="Procurar"
            icon={<SearchRoundedIcon />}
            onInput={triggerSearchTime}
            clear
          />
        </div>
        <div className="adsList">
          {ads.map(
            (ad) =>
              ad.active === activeFilter && (
                <React.Fragment key={ad.id}>
                  <Chip class="adChip" k={ad.id} id={ad.id} callback={handleMenu.open}>
                    <>
                      <div className="adTVContent">
                        <VideocamRounded />
                        <span className="adNameItem">{ad.name}</span>
                      </div>
                      {ad.percentageRate && ad.percentageRate > 0 && (
                        <div className="adPercentageContent">
                          <span className="adPercentageItem">{ad.percentageRate}%</span>
                        </div>
                      )}
                    </>
                  </Chip>
                  {(checkPermission(permissions.roomTvAds, "view") ||
                    checkPermission(permissions.roomTvAds, "edit") ||
                    checkPermission(permissions.roomTvAds, "delete")) && (
                    <Menu
                      id="tvAdMenu"
                      anchorEl={anchorEl}
                      open={openMenu}
                      onClose={handleMenu.close}
                      sx={menuSX}
                    >
                      {checkPermission(permissions.roomTvAds, "view") && (
                        <MenuItem
                          className="colRoleMenu"
                          onClick={() =>
                            setPlay({
                              playing: true,
                              id: candidateAdId.current,
                            })
                          }
                        >
                          <FontAwesomeIcon icon={faPlay} fixedWidth />
                          <span>Visualizar</span>
                        </MenuItem>
                      )}
                      {checkPermission(permissions.roomTvAds, "edit") && (
                        <MenuItem className="colRoleMenu" onClick={Details.config}>
                          <FontAwesomeIcon icon={faCog} fixedWidth />
                          <span>Configurações</span>
                        </MenuItem>
                      )}
                      {checkPermission(permissions.roomTvAds, "delete") && (
                        <MenuItem className="colRoleMenu" onClick={APIEvents.deleteTVAd}>
                          <FontAwesomeIcon icon={faClose} fixedWidth />
                          <span>Excluir</span>
                        </MenuItem>
                      )}
                    </Menu>
                  )}
                </React.Fragment>
              ),
          )}
        </div>
      </div>
    </>
  );
}

export function Hall() {
  const { orgIsOnlyForAdults } = useUser();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [detailState, setDetailState] = React.useState<"create" | "edit">();
  const [activeFilter, setActiveFilter] = React.useState(true);
  const [ads, setAds] = React.useState<HallAdsProps[]>([]);
  const [search, setSearch] = React.useState("");
  const [bandwidthMbps] = React.useState(() => getBandwidthMbps());

  const [bannerFeedbackIsOpen, setBannerFeedbackIsOpen] = React.useState(false);
  const [bannerFeedbackType, setBannerFeedbackType] = React.useState<
    "error" | "success" | "warning" | "info"
  >("error");
  const [bannerFeedbackMessage, setBannerFeedbackMessage] = React.useState("");

  const candidateAdId = React.useRef<string>("");
  const bounceTimeNodeRef = React.useRef<NodeJS.Timeout | null>(null);
  const numBounceTimeRef = React.useRef<number>(300);
  const { permissions } = usePermissions();

  async function triggerSearchTime(e: React.FormEvent<HTMLInputElement>) {
    if (bounceTimeNodeRef.current) {
      clearTimeout(bounceTimeNodeRef.current);
    }

    bounceTimeNodeRef.current = setTimeout(() => {
      setSearch((e.target as HTMLInputElement).value);
    }, numBounceTimeRef.current);
  }

  class SocketEvents {
    static async receiveNewUploadItem() {
      const info = await sessionInfo();
      if (!info) return;
      RTA.emit(`openUploadToast-${info.org_id}-${info.iss}`);
      triggerUploadToastOpen();
    }

    static concludeUploadItem(payload: any) {
      if (payload.status !== "success") return false;
      const newPayload: HallAdsProps = {
        id: payload.adId,
        components: payload.components,
        active: payload.active,
        label: payload.label,
        isAdult: payload.isAdult,
        tags: payload.tags,
        headline: payload.headline,
      };

      if (payload.percentageRate && payload.active) {
        newPayload.percentageRate = payload.percentageRate;
      }

      setAds((prev) => {
        // Idempotent with the create-flow refetch: never append an ad the list
        // already holds, so the socket path and the refetch cannot duplicate it.
        if (prev.some((ad) => ad.id === newPayload.id)) return prev;
        const updated = [...prev, newPayload];
        return updated.sort((a, b) => {
          const x = a.percentageRate ?? -Infinity;
          const y = b.percentageRate ?? -Infinity;
          return y - x;
        });
      });
    }
  }

  class APIEvents {
    static async listHallAds() {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const currAds: HallAdsProps[] = [];
      const size = 150;
      let query = `/hall`;
      if (search.trim()) query += `?search=${search.trim()}`;
      for (let page = 0; ; page++) {
        try {
          const res = await adsAPI.get(query, {
            headers: headers,
            params: { page, size, bandwidthMbps },
          });
          if (!res.data) {
            setAds(currAds);
            return;
          }
          const hallAds = res.data as HallAdsProps[];
          currAds.push(...hallAds);
          if (hallAds.length < size) {
            setAds(
              currAds.sort((a, b) => {
                const x = a.percentageRate ?? -Infinity;
                const y = b.percentageRate ?? -Infinity;
                return y - x;
              }),
            );
            return;
          }
        } catch (err: any) {
          console.error(err);
          return;
        }
      }
    }

    static async deleteHallAd(id: string) {
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      try {
        await adsAPI.delete(`/hall/${id}`, { headers: headers });
        setAds(ads.filter((ad) => ad.id !== id));
        setBannerFeedbackType("success");
        setBannerFeedbackMessage(`Anúncio excluído com sucesso`);
        setBannerFeedbackIsOpen(true);
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackType("error");
        setBannerFeedbackIsOpen(true);
        setBannerFeedbackMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível excluir o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        candidateAdId.current = "";
      }
    }
  }

  const SelectedComponent: React.FC<{
    selectedComponent: HallAdComponentProps | undefined;
    modifiedAd: (ad: HallAdComponentProps) => void;
    callbackDeleteAd?: (id: string) => void;
  }> = React.memo(
    (props) => {
      const [selectedTopic, setSelectedTopic] = React.useState<"builder" | "css">("builder");
      const markersRef = React.useRef<editor.IMarker[]>([]);
      const changeTimeoutRef = React.useRef<NodeJS.Timeout>();

      const SelectedTopicCSS: React.FC<{ selectedComponent: HallAdComponentProps }> = ({
        selectedComponent,
      }) => {
        return (
          <MonacoEditor
            defaultLanguage="css"
            theme="vs-dark"
            height={400}
            width={320}
            className="hallCssEditor"
            options={{
              minimap: { enabled: false },
              lineNumbers: "off",
              fontSize: 12,
              scrollBeyondLastLine: false,
              automaticLayout: true,
              lineNumbersMinChars: 0,
              scrollbar: {
                vertical: "hidden",
                horizontal: "hidden",
              },
              tabSize: 2,
              insertSpaces: true,
              detectIndentation: false,
            }}
            defaultValue={`/* CSS apenas funcionará no \nprimeiro seletor */\n#${selectedComponent.type}NameExample {\n${convertCSSToString(selectedComponent.css, 1)}}`}
            onValidate={(markers) => {
              markersRef.current = markers;
            }}
            onChange={(value) => {
              if (changeTimeoutRef.current) clearTimeout(changeTimeoutRef.current);
              changeTimeoutRef.current = setTimeout(() => {
                if (!selectedComponent) return;
                if (markersRef.current.length) return;

                const css = convertStringToCSS(value ?? "");
                selectedComponent.css = css;
                props.modifiedAd({ ...selectedComponent });
              }, 750);
            }}
          />
        );
      };

      const ButtonTypeSelected: React.FC<{ selectedComponent: HallAdComponentProps }> = ({
        selectedComponent,
      }) => {
        return (
          <>
            <div className="selectedTopicsComponent">
              <span
                className="hallTopic topicLeft"
                id={selectedTopic === "builder" ? "activeTopicHallAd" : ""}
                onClick={() => setSelectedTopic("builder")}
              >
                Builder
              </span>
              <span
                className="hallTopic topicRight"
                id={selectedTopic === "css" ? "activeTopicHallAd" : ""}
                onClick={() => setSelectedTopic("css")}
              >
                CSS
              </span>
            </div>
            {selectedTopic === "builder" && (
              <>
                <div className="hallFeatureRow">
                  <label htmlFor={`componentColor_${selectedComponent.id}`}>
                    <input
                      type="color"
                      id={`componentColor_${selectedComponent.id}`}
                      onChange={(ev) => {
                        if (!selectedComponent) return;
                        const color = (ev.target as HTMLInputElement).value;
                        selectedComponent.css = {
                          ...selectedComponent.css,
                          backgroundColor: color,
                        };
                        props.modifiedAd({ ...selectedComponent });
                      }}
                      style={{ visibility: "hidden", position: "absolute" }}
                      defaultValue={selectedComponent.css.backgroundColor}
                    />
                    <div
                      className="hallColorChar"
                      style={{ backgroundColor: selectedComponent.css.backgroundColor }}
                    />
                  </label>
                  <label htmlFor={`componentColorText_${selectedComponent.id}`}>
                    <input
                      type="color"
                      id={`componentColorText_${selectedComponent.id}`}
                      onChange={(e) => {
                        if (!selectedComponent) return;
                        const color = (e.target as HTMLInputElement).value;
                        selectedComponent.css = { ...selectedComponent.css, color: color };
                        props.modifiedAd({ ...selectedComponent });
                      }}
                      style={{ visibility: "hidden", position: "absolute" }}
                      defaultValue={selectedComponent.css.color}
                    />
                    <div className="hallColorText">
                      <span>A</span>
                      <div style={{ background: selectedComponent.css.color }} />
                    </div>
                  </label>
                  <NumberField
                    class="hallComponentFontSize"
                    icon={<TextIncreaseRounded />}
                    value={onlyIntegers((selectedComponent.css.fontSize as string) ?? "14px")}
                    onInput={(e) => {
                      if (!selectedComponent) return;
                      const size = Number((e.target as HTMLInputElement).value);
                      selectedComponent.css = { ...selectedComponent.css, fontSize: `${size}px` };
                      props.modifiedAd({ ...selectedComponent });
                    }}
                    min={0}
                    max={100}
                  />
                </div>
                <Select
                  containerId={`componentFontFamily_${selectedComponent.id}`}
                  idBox={`componentFontFamily_${selectedComponent.id}`}
                  className="hallComponentFontFamily"
                  classNameBox="hallComponentFontFamilyBox"
                  options={AVAILABLE_FONTS}
                  optionsValues={AVAILABLE_FONTS}
                  defaultValue={hallAdFont(selectedComponent.css.fontFamily)}
                  label="Fontes"
                  selectValue={(value) => {
                    if (!selectedComponent) return;
                    const v = hallAdFont(value);
                    selectedComponent.css = { ...selectedComponent.css, fontFamily: v };
                    props.modifiedAd({ ...selectedComponent });
                  }}
                />
              </>
            )}
            {selectedTopic === "css" && <SelectedTopicCSS selectedComponent={selectedComponent} />}
            <hr className="hallComponentDivisor" />
            <div className="hallFields">
              <TextField
                class="hallComponentText"
                placeholder="Texto do botão"
                onInput={(e) => {
                  if (!selectedComponent) return;
                  selectedComponent.text = (e.target as HTMLInputElement).value;
                  props.modifiedAd({ ...selectedComponent });
                }}
                defaultValue={selectedComponent.text}
                icon={<AbcRounded />}
              />
              <TextField
                class="hallComponentLink"
                placeholder="Link do botão"
                onInput={(e) => {
                  if (!selectedComponent) return;
                  selectedComponent.link = (e.target as HTMLInputElement).value;
                  props.modifiedAd({ ...selectedComponent });
                }}
                defaultValue={selectedComponent.link}
                icon={<LinkRounded />}
              />
              <div className="hallFeatureRowWithoutMargin">
                <NumberField
                  class="hallComponentZIndex"
                  icon={<LayersRounded />}
                  value={onlyIntegers(String(selectedComponent.zIndex) ?? "1")}
                  onInput={(e) => {
                    if (!selectedComponent) return;
                    const zIndex = Number((e.target as HTMLInputElement).value);
                    selectedComponent.zIndex = zIndex;
                    props.modifiedAd({ ...selectedComponent });
                  }}
                  min={-100}
                  max={100}
                />
                <button className="hallOptionOnlyIcon" onClick={centerVertically}>
                  <VerticalAlignCenterRounded />
                </button>
                <button className="hallOptionOnlyIcon" onClick={centerHorizontally}>
                  <VerticalAlignCenterRounded
                    sx={{
                      transform: "rotate(90deg)",
                    }}
                  />
                </button>
              </div>
              <Button
                type="danger"
                icon={<DeleteRounded />}
                class="hallComponentDelete"
                iconSlot="start"
                callback={() => {
                  const adSel = selectedComponent;
                  if (!adSel) return;
                  if (props.callbackDeleteAd) props.callbackDeleteAd(adSel.id);
                }}
              >
                Deletar
              </Button>
            </div>
          </>
        );
      };

      const TextTypeSelected: React.FC<{ selectedComponent: HallAdComponentProps }> = ({
        selectedComponent,
      }) => {
        const [selectedAlignment, setSelectedAlignment] = React.useState<string>(
          selectedComponent.css.textAlign || "left",
        );

        return (
          <>
            <div className="selectedTopicsComponent">
              <span
                className="hallTopic topicLeft"
                id={selectedTopic === "builder" ? "activeTopicHallAd" : ""}
                onClick={() => setSelectedTopic("builder")}
              >
                Builder
              </span>
              <span
                className="hallTopic topicRight"
                id={selectedTopic === "css" ? "activeTopicHallAd" : ""}
                onClick={() => setSelectedTopic("css")}
              >
                CSS
              </span>
            </div>
            {selectedTopic === "builder" && (
              <>
                <div className="hallFeatureRow">
                  <label htmlFor={`componentColor_${selectedComponent.id}`}>
                    <input
                      type="color"
                      id={`componentColor_${selectedComponent.id}`}
                      onChange={(ev) => {
                        if (!selectedComponent) return;
                        const color = (ev.target as HTMLInputElement).value;
                        selectedComponent.css = {
                          ...selectedComponent.css,
                          backgroundColor: color,
                        };
                        props.modifiedAd({ ...selectedComponent });
                      }}
                      style={{ visibility: "hidden", position: "absolute" }}
                      defaultValue={selectedComponent.css.backgroundColor}
                    />
                    <div
                      className="hallColorChar"
                      style={{ backgroundColor: selectedComponent.css.backgroundColor }}
                    />
                  </label>
                  <label htmlFor={`componentColorText_${selectedComponent.id}`}>
                    <input
                      type="color"
                      id={`componentColorText_${selectedComponent.id}`}
                      onChange={(e) => {
                        if (!selectedComponent) return;
                        const color = (e.target as HTMLInputElement).value;
                        selectedComponent.css = { ...selectedComponent.css, color: color };
                        props.modifiedAd({ ...selectedComponent });
                      }}
                      style={{ visibility: "hidden", position: "absolute" }}
                      defaultValue={selectedComponent.css.color}
                    />
                    <div className="hallColorText">
                      <span>A</span>
                      <div style={{ background: selectedComponent.css.color }} />
                    </div>
                  </label>
                  <NumberField
                    class="hallComponentFontSize"
                    icon={<TextIncreaseRounded />}
                    value={onlyIntegers((selectedComponent.css.fontSize as string) ?? "14px")}
                    onInput={(e) => {
                      if (!selectedComponent) return;
                      const size = Number((e.target as HTMLInputElement).value);
                      selectedComponent.css = { ...selectedComponent.css, fontSize: `${size}px` };
                      props.modifiedAd({ ...selectedComponent });
                    }}
                    min={0}
                    max={100}
                  />
                  <button
                    className="hallOptionOnlyIcon"
                    style={{
                      backgroundColor:
                        selectedAlignment === "left" ? "var(--brand-5)" : "var(--brand-3)",
                    }}
                    onClick={() => {
                      if (!selectedComponent) return;
                      setSelectedAlignment("left");
                      selectedComponent.css = { ...selectedComponent.css, textAlign: "left" };
                      props.modifiedAd({ ...selectedComponent });
                    }}
                  >
                    <FormatAlignLeftRounded />
                  </button>
                  <button
                    className="hallOptionOnlyIcon"
                    style={{
                      backgroundColor:
                        selectedAlignment === "center" ? "var(--brand-5)" : "var(--brand-3)",
                    }}
                    onClick={() => {
                      if (!selectedComponent) return;
                      setSelectedAlignment("center");
                      selectedComponent.css = { ...selectedComponent.css, textAlign: "center" };
                      props.modifiedAd({ ...selectedComponent });
                    }}
                  >
                    <FormatAlignCenterRounded />
                  </button>
                  <button
                    className="hallOptionOnlyIcon"
                    style={{
                      backgroundColor:
                        selectedAlignment === "right" ? "var(--brand-5)" : "var(--brand-3)",
                    }}
                    onClick={() => {
                      if (!selectedComponent) return;
                      setSelectedAlignment("right");
                      selectedComponent.css = { ...selectedComponent.css, textAlign: "right" };
                      props.modifiedAd({ ...selectedComponent });
                    }}
                  >
                    <FormatAlignRightRounded />
                  </button>
                </div>
                <Select
                  containerId={`componentFontFamily_${selectedComponent.id}`}
                  idBox={`componentFontFamily_${selectedComponent.id}`}
                  className="hallComponentFontFamily"
                  classNameBox="hallComponentFontFamilyBox"
                  options={AVAILABLE_FONTS}
                  optionsValues={AVAILABLE_FONTS}
                  defaultValue={hallAdFont(selectedComponent.css.fontFamily)}
                  label="Fontes"
                  selectValue={(value) => {
                    if (!selectedComponent) return;
                    const v = hallAdFont(value);
                    selectedComponent.css = { ...selectedComponent.css, fontFamily: v };
                    props.modifiedAd({ ...selectedComponent });
                  }}
                />
              </>
            )}
            {selectedTopic === "css" && <SelectedTopicCSS selectedComponent={selectedComponent} />}
            <hr className="hallComponentDivisor" />
            <div className="hallFields">
              <TextField
                class="hallComponentText"
                placeholder="Texto do botão"
                onInput={(e) => {
                  if (!selectedComponent) return;
                  selectedComponent.text = (e.target as HTMLInputElement).value;
                  props.modifiedAd({ ...selectedComponent });
                }}
                defaultValue={selectedComponent.text}
                icon={<AbcRounded />}
              />
              <div className="hallFeatureRowWithoutMargin">
                <NumberField
                  class="hallComponentZIndex"
                  icon={<LayersRounded />}
                  value={onlyIntegers(String(selectedComponent.zIndex) ?? "1")}
                  onInput={(e) => {
                    if (!selectedComponent) return;
                    const zIndex = Number((e.target as HTMLInputElement).value);
                    selectedComponent.zIndex = zIndex;
                    props.modifiedAd({ ...selectedComponent });
                  }}
                  min={-100}
                  max={100}
                />
                <button className="hallOptionOnlyIcon" onClick={centerVertically}>
                  <VerticalAlignCenterRounded />
                </button>
                <button className="hallOptionOnlyIcon" onClick={centerHorizontally}>
                  <VerticalAlignCenterRounded
                    sx={{
                      transform: "rotate(90deg)",
                    }}
                  />
                </button>
              </div>
              <Button
                type="danger"
                icon={<DeleteRounded />}
                class="hallComponentDelete"
                iconSlot="start"
                callback={() => {
                  const adSel = selectedComponent;
                  if (!adSel) return;
                  if (props.callbackDeleteAd) props.callbackDeleteAd(adSel.id);
                }}
              >
                Deletar
              </Button>
            </div>
          </>
        );
      };

      const ImageTypeSelected: React.FC<{ selectedComponent: HallAdComponentProps }> = ({
        selectedComponent,
      }) => {
        return (
          <>
            <div className="selectedTopicsComponent">
              <span
                className="hallTopic topicLeft"
                id={selectedTopic === "builder" ? "activeTopicHallAd" : ""}
                onClick={() => setSelectedTopic("builder")}
              >
                Builder
              </span>
              <span
                className="hallTopic topicRight"
                id={selectedTopic === "css" ? "activeTopicHallAd" : ""}
                onClick={() => setSelectedTopic("css")}
              >
                CSS
              </span>
            </div>
            {selectedTopic === "builder" && (
              <div className="hallFeatureRow">
                <label htmlFor={`componentColor_${selectedComponent.id}`}>
                  <input
                    type="color"
                    id={`componentColor_${selectedComponent.id}`}
                    onChange={(ev) => {
                      if (!selectedComponent) return;
                      const color = (ev.target as HTMLInputElement).value;
                      selectedComponent.css = { ...selectedComponent.css, backgroundColor: color };
                      props.modifiedAd({ ...selectedComponent });
                    }}
                    style={{ visibility: "hidden", position: "absolute" }}
                    defaultValue={selectedComponent.css.backgroundColor}
                  />
                  <div
                    className="hallColorChar"
                    style={{ backgroundColor: selectedComponent.css.backgroundColor }}
                  />
                </label>
              </div>
            )}
            {selectedTopic === "css" && <SelectedTopicCSS selectedComponent={selectedComponent} />}
            <hr className="hallComponentDivisor" />
            <div className="hallFields">
              <div className="hallFeatureRowWithoutMargin">
                <NumberField
                  class="hallComponentZIndex"
                  icon={<LayersRounded />}
                  value={onlyIntegers(String(selectedComponent.zIndex) ?? "1")}
                  onInput={(e) => {
                    if (!selectedComponent) return;
                    const zIndex = Number((e.target as HTMLInputElement).value);
                    selectedComponent.zIndex = zIndex;
                    props.modifiedAd({ ...selectedComponent });
                  }}
                  min={-100}
                  max={100}
                />
                <button className="hallOptionOnlyIcon" onClick={centerVertically}>
                  <VerticalAlignCenterRounded />
                </button>
                <button className="hallOptionOnlyIcon" onClick={centerHorizontally}>
                  <VerticalAlignCenterRounded
                    sx={{
                      transform: "rotate(90deg)",
                    }}
                  />
                </button>
              </div>
              <Button
                type="danger"
                icon={<DeleteRounded />}
                class="hallComponentDelete"
                iconSlot="start"
                callback={() => {
                  const adSel = selectedComponent;
                  if (!adSel) return;
                  if (props.callbackDeleteAd) props.callbackDeleteAd(adSel.id);
                }}
              >
                Deletar
              </Button>
            </div>
          </>
        );
      };

      const BackgroundTypeSelected: React.FC<{ selectedComponent: HallAdComponentProps }> = ({
        selectedComponent,
      }) => {
        return (
          <>
            <div className="selectedTopicsComponent">
              <span
                className="hallTopic topicLeft"
                id={selectedTopic === "builder" ? "activeTopicHallAd" : ""}
                onClick={() => setSelectedTopic("builder")}
              >
                Builder
              </span>
              <span
                className="hallTopic topicRight"
                id={selectedTopic === "css" ? "activeTopicHallAd" : ""}
                onClick={() => setSelectedTopic("css")}
              >
                CSS
              </span>
            </div>
            {selectedTopic === "builder" && (
              <div className="hallFeatureRow">
                <label htmlFor="componentColorBackground">
                  <input
                    type="color"
                    id="componentColorBackground"
                    onChange={(ev) => {
                      if (!selectedComponent) return;
                      const color = (ev.target as HTMLInputElement).value;
                      selectedComponent.css = { ...selectedComponent.css, backgroundColor: color };
                      props.modifiedAd({ ...selectedComponent });
                    }}
                    style={{ visibility: "hidden", position: "absolute" }}
                    defaultValue={selectedComponent.css.backgroundColor}
                  />
                  <div
                    className="hallColorChar"
                    style={{ backgroundColor: selectedComponent.css.backgroundColor }}
                  />
                </label>
              </div>
            )}
            {selectedTopic === "css" && <SelectedTopicCSS selectedComponent={selectedComponent} />}
          </>
        );
      };

      function convertStringToCSS(css: string, stopInFirst: boolean = false) {
        const cssObject: React.CSSProperties = {};
        css.split(/[{;]/g).forEach((line) => {
          if (stopInFirst) {
            if (line.includes("}")) return;
          }

          if (!line.includes(":")) return;
          const [key, value] = line.split(":");
          if (!key || !value) return;

          let k = key.trim();
          let v = value.trim();
          if (k.includes("-")) {
            k = k
              .split("-")
              .map((word, index) => {
                if (index === 0) return word;
                return word.charAt(0).toUpperCase() + word.slice(1);
              })
              .join("");
          }
          (cssObject as any)[k] = v;
        });
        return cssObject;
      }

      function convertCSSToString(css: React.CSSProperties, tab: number = 0) {
        let cssString = "";
        for (const key in css) {
          if (!css.hasOwnProperty(key)) continue;
          const value = (css as any)[key];
          const k = key.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);
          cssString += `${"\t".repeat(tab)}${k}: ${value};\n`;
        }
        return cssString;
      }

      function deletePressingDelKey(this: Document, ev: KeyboardEvent) {
        if (ev.key !== "Delete") return;
        const adSel = props.selectedComponent;
        if (!adSel) return;
        if (props.callbackDeleteAd) props.callbackDeleteAd(adSel.id);
      }

      function centerHorizontally() {
        if (!props.selectedComponent) return;
        const width = parseFloat(
          String(hallAdStyle(props.selectedComponent.type, props.selectedComponent.css).width),
        );
        props.selectedComponent.x = HALL_BOARD_WIDTH / 2 - width / 2;
        props.modifiedAd({ ...props.selectedComponent });
      }

      function centerVertically() {
        if (!props.selectedComponent) return;
        const height = parseFloat(
          String(hallAdStyle(props.selectedComponent.type, props.selectedComponent.css).height),
        );
        props.selectedComponent.y = HALL_BOARD_HEIGHT / 2 - height / 2;
        props.modifiedAd({ ...props.selectedComponent });
      }

      React.useEffect(() => {
        if (!props.selectedComponent) return;
        document.addEventListener("keydown", deletePressingDelKey);
        return () => {
          document.removeEventListener("keydown", deletePressingDelKey);
        };
      }, [props.selectedComponent]);

      if (!props.selectedComponent) return <></>;
      let componentEditor = <></>;

      switch (props.selectedComponent.type) {
        case "button":
          componentEditor = <ButtonTypeSelected selectedComponent={props.selectedComponent} />;
          break;
        case "text":
          componentEditor = <TextTypeSelected selectedComponent={props.selectedComponent} />;
          break;
        case "image":
          componentEditor = <ImageTypeSelected selectedComponent={props.selectedComponent} />;
          break;
        case "background":
          componentEditor = <BackgroundTypeSelected selectedComponent={props.selectedComponent} />;
          break;
      }

      return (
        <div className="selectedComponentEditor" key={props.selectedComponent.id}>
          {componentEditor}
        </div>
      );
    },
    (prev, next) => {
      const prevSel = prev.selectedComponent;
      const nextSel = next.selectedComponent;
      if (!prevSel && !nextSel) return true;
      if (!prevSel || !nextSel) return false;
      if (prevSel.id !== nextSel.id) return false;
      if (prevSel.editorChangedSeed !== nextSel.editorChangedSeed) return false;
      return true;
    },
  );

  const HallEditor = () => {
    const chosedAd =
      detailState === "edit" ? ads.find((ad) => ad.id === candidateAdId.current) : undefined;
    const [loading, setLoading] = React.useState(false);
    const chosedAdComponents = parseHallAdComponents(chosedAd?.components);
    const [components, setComponents] = React.useState<HallAdComponentProps[]>(
      chosedAdComponents
        ? [
            ...chosedAdComponents.components,
            {
              id: Math.random().toString(36).substring(7),
              type: "background",
              css: chosedAdComponents.background ?? { backgroundColor: "#ffffff" },
            },
          ]
        : [],
    );
    const [selectedComponent, setSelectedComponent] = React.useState<HallAdComponentProps>();
    const [inGrab, setInGrab] = React.useState(false);
    const [cancelling, setCancelling] = React.useState(false);
    const [bannerFeedbackEditorIsOpen, setBannerFeedbackEditorIsOpen] = React.useState(false);
    const [bannerFeedbackEditorType, setBannerFeedbackEditorType] = React.useState<
      "error" | "success" | "warning" | "info"
    >("error");
    const [bannerFeedbackEditorMessage, setBannerFeedbackEditorMessage] = React.useState("");
    const [label, setLabel] = React.useState<string>(chosedAd?.label ?? "");
    const [headline, setHeadline] = React.useState<string>(chosedAd?.headline ?? "");
    const [isAdult, setIsAdult] = React.useState<boolean>(
      initialCreativeAdultFlag(chosedAd?.isAdult, orgIsOnlyForAdults),
    );
    const [openFrequency, setOpenFrequency] = React.useState<boolean>(
      chosedAd?.percentageRate ? true : false,
    );
    const [frequencyValue, setFrequencyValue] = React.useState<number>(
      chosedAd?.percentageRate ?? 60,
    );
    const [tags, setTags] = React.useState<string[]>(chosedAd?.tags ?? []);
    const [active, setActive] = React.useState<boolean>(chosedAd?.active ?? true);

    const mapFilesImages = React.useRef<{ [key: string]: File }>({});
    const anchorGrab = React.useRef<{ x: number; y: number }>();
    const anchorDimension = React.useRef<{ x: number; y: number }>();
    const eventMoveDimensionId = React.useRef<string>("");
    const grabId = React.useRef<HallAdComponentProps>();
    const cancelTimeout = React.useRef<NodeJS.Timeout>();

    React.useEffect(() => {
      if (!detailState || detailState === "create") {
        mapFilesImages.current = {};
      }
    }, [detailState]);

    class HallComponent {
      static initNewButton() {
        const id = Math.random().toString(36).substring(7);
        const newComponent: HallAdComponentProps = {
          id: id,
          type: "button",
          text: "Escreva algo",
          css: {
            backgroundColor: "#00aa00",
            color: "#ffffff",
            fontSize: "14px",
            width: "200px",
            height: "40px",
            fontFamily: "Arimo",
            border: "none",
            borderRadius: "9999px",
          },
          zIndex: 2,
          x: 40,
          y: 250,
          rotation: 0,
          editorChangedSeed: Math.random().toString(36).substring(7),
        };

        setComponents([...components, newComponent]);
        setSelectedComponent(newComponent);
      }

      static initNewText() {
        const id = Math.random().toString(36).substring(7);
        const newComponent: HallAdComponentProps = {
          id: id,
          type: "text",
          text: "Escreva algo",
          css: {
            display: "block",
            color: "#000000",
            fontSize: "14px",
            width: "100px",
            height: "40px",
            fontFamily: "Arimo",
            textAlign: "center",
          },
          zIndex: 1,
          x: 40,
          y: 250,
          rotation: 0,
          editorChangedSeed: Math.random().toString(36).substring(7),
        };

        setComponents([...components, newComponent]);
        setSelectedComponent(newComponent);
      }

      static initNewImage(e: React.ChangeEvent<HTMLInputElement>) {
        const ele = e.target;
        if (!ele.files) return;
        if (!ele.files[0]) return;

        const file = ele.files[0];
        const reader = new FileReader();
        reader.onload = (ev) => {
          const id = crypto.randomUUID();
          const newComponent: HallAdComponentProps = {
            id: id,
            type: "image",
            src: id,
            preview: ev.target?.result as string,
            css: {
              width: "200px",
              height: "200px",
              objectFit: "contain",
            },
            x: 40,
            y: 250,
            rotation: 0,
            zIndex: 0,
            editorChangedSeed: Math.random().toString(36).substring(7),
          };

          mapFilesImages.current[id] = file;
          ele.value = "";
          setComponents([...components, newComponent]);
          setSelectedComponent(newComponent);
        };

        reader.readAsDataURL(file);
      }

      static configureBackgroundCard() {
        if (components.find((component) => component.type === "background")) {
          setSelectedComponent(components.find((component) => component.type === "background"));
          return;
        }

        const id = Math.random().toString(36).substring(7);
        const newComponent: HallAdComponentProps = {
          id: id,
          type: "background",
          css: {
            backgroundColor: "#ffffff",
          },
          x: 0,
          y: 0,
          rotation: 0,
          zIndex: -1,
          editorChangedSeed: Math.random().toString(36).substring(7),
        };

        setComponents([...components, newComponent]);
        setSelectedComponent(newComponent);
      }

      static editComponent = (ad: HallAdComponentProps) => {
        setComponents(
          components.map((component) => {
            if (component.id === ad.id) {
              component = ad;
            }
            return component;
          }),
        );
      };
    }

    class GrabSelected {
      static start(e: React.MouseEvent<HTMLDivElement>) {
        const id = e.currentTarget.id.split("_")[1];
        e.stopPropagation();
        const hallAdSelected = components.find((component) => component.id === id);
        setSelectedComponent(hallAdSelected);
        setInGrab(true);
        grabId.current = hallAdSelected;
        document.addEventListener("mouseup", GrabSelected.end, { once: true });
        document.addEventListener("mousemove", GrabSelected.move);
        anchorGrab.current = { x: e.clientX, y: e.clientY };
      }

      static move(this: Document, ev: MouseEvent) {
        if (!grabId.current || !anchorGrab.current) return;
        const x = grabId.current.x + (ev.clientX - anchorGrab.current.x);
        const y = grabId.current.y + (ev.clientY - anchorGrab.current.y);
        grabId.current.x = x;
        grabId.current.y = y;
        anchorGrab.current = { x: ev.clientX, y: ev.clientY };
        grabId.current.editorChangedSeed = Math.random().toString(36).substring(7);
        HallComponent.editComponent(grabId.current);
      }

      static end() {
        anchorGrab.current = undefined;
        setInGrab(false);
        document.removeEventListener("mousemove", GrabSelected.move);
      }
    }

    class SelectDimension {
      static start(e: React.MouseEvent<HTMLDivElement>) {
        if (!selectedComponent) return;
        e.stopPropagation();
        eventMoveDimensionId.current = `hallItemComponent_${selectedComponent.id}`;
        document.addEventListener("mouseup", SelectDimension.end, { once: true });
        document.addEventListener("mousemove", SelectDimension.move);
        anchorDimension.current = { x: e.clientX, y: e.clientY };
      }

      static move(this: Document, ev: MouseEvent) {
        if (!selectedComponent || !anchorDimension.current) return;
        const ele = document.getElementById(eventMoveDimensionId.current) as HTMLDivElement;
        const r = ele.getBoundingClientRect();
        const width = `${ev.clientX - r.left}px`;
        const height = `${ev.clientY - r.top}px`;
        selectedComponent.css = { ...selectedComponent.css, width: width, height: height };
        selectedComponent.editorChangedSeed = Math.random().toString(36).substring(7);
        anchorDimension.current = { x: ev.clientX, y: ev.clientY };
        HallComponent.editComponent(selectedComponent);
      }

      static end() {
        anchorDimension.current = undefined;
        document.removeEventListener("mousemove", SelectDimension.move);
      }
    }

    class RotateSelected {
      static start(e: React.MouseEvent<HTMLDivElement>) {
        if (!selectedComponent) return;
        e.stopPropagation();
        document.addEventListener("mouseup", RotateSelected.end, { once: true });
        document.addEventListener("mousemove", RotateSelected.move);
        anchorDimension.current = { x: e.clientX, y: e.clientY };
      }

      static move(this: Document, ev: MouseEvent) {
        if (!selectedComponent || !anchorDimension.current) return;
        const ele = document.getElementById(
          `hallItemComponent_${selectedComponent.id}`,
        ) as HTMLDivElement;
        const r = ele.getBoundingClientRect();
        const x = r.left + r.width / 2;
        const y = r.top + r.height / 2;
        const angle = Math.atan2(ev.clientY - y, ev.clientX - x) * (180 / Math.PI);
        selectedComponent.rotation = angle + 90;
        selectedComponent.editorChangedSeed = Math.random().toString(36).substring(7);
        HallComponent.editComponent(selectedComponent);
      }

      static end() {
        anchorDimension.current = undefined;
        document.removeEventListener("mousemove", RotateSelected.move);
      }
    }

    function disableEdit() {
      if (label.trim().length <= 0) return true;
      if (label.trim().length > 50) return true;
      if (headline.trim() && headline.trim().length > 60) return true;
      if (components.length === 0) return true;
      if (tags.length < 3) return true;
      if (tags.length > 7) return true;

      if (openFrequency && frequencyValue <= 0) return true;
      if (
        openFrequency &&
        calculateSumPercentageRateByTargetAdId(
          ads,
          chosedAd!.id,
          openFrequency ? frequencyValue : 0,
        ) > 100
      ) {
        return true;
      }

      return false;
    }

    function disableCreate() {
      if (label.trim().length <= 0) return true;
      if (label.trim().length > 50) return true;
      if (headline.trim() && headline.trim().length > 60) return true;
      if (components.length === 0) return true;
      if (tags.length < 3) return true;
      if (tags.length > 7) return true;

      if (openFrequency && frequencyValue <= 0) return true;
      if (openFrequency && getSumPercentageRateAds(ads) + frequencyValue > 100) {
        return true;
      }

      return false;
    }

    function clickOutside(e: React.MouseEvent<HTMLDivElement>) {
      if (e.target !== e.currentTarget) return;
      setSelectedComponent(undefined);
    }

    function selectBackground(e: React.MouseEvent<HTMLDivElement>) {
      e.stopPropagation();
      const ele = e.target as HTMLDivElement;
      if (ele.id !== "hallScreenEditorContent") return;
      const backgroundComponent = components.find((component) => component.type === "background");
      if (!backgroundComponent) return;
      setSelectedComponent(backgroundComponent);
    }

    function startCancelling() {
      setCancelling(true);
      document.addEventListener("mouseup", cancelCancelling, { once: true });
      cancelTimeout.current = setTimeout(() => {
        setDetailState(undefined);
      }, 1500);
    }

    function cancelCancelling() {
      setCancelling(false);
      if (cancelTimeout.current) clearTimeout(cancelTimeout.current);
    }

    async function createHallAd() {
      setLoading(true);

      const background = components.find((component) => component.type === "background");
      const componentsWithoutBg = components.filter((component) => component.type !== "background");
      const invalidStyle = components
        .map((component) => hallAdStyleError(component.css))
        .find(Boolean);
      if (invalidStyle) {
        setBannerFeedbackEditorMessage(invalidStyle);
        setBannerFeedbackEditorType("error");
        setBannerFeedbackEditorIsOpen(true);
        setLoading(false);
        return;
      }
      const refinedComponents = componentsWithoutBg.map((component) => {
        const { preview, editorChangedSeed, ...rest } = component;
        return serializeHallAdPart(rest);
      });

      const generalComponent = {
        components: refinedComponents,
        background: hallAdBackground(background?.css),
      };

      const validateTable: { [key: string]: boolean } = {
        "A label precisa ser preenchida": label.trim().length > 0,
        "A label pode ter no máximo 50 caracteres": label.trim().length <= 50,
        "A headline pode ter no máximo 60 caracteres":
          !headline.trim() || headline.trim().length <= 60,
        "O anúncio está vazio": components.length > 0,
        "Precisam ter no minimo 3 tags": tags.length >= 3,
        "Precisam ter no máximo 7 tags": tags.length <= 7,
        "A taxa de frequência precisa ser maior que 0%": !openFrequency || frequencyValue > 0,
        "A soma das taxas de frequência não pode ser maior que 100%":
          !openFrequency || getSumPercentageRateAds(ads) + frequencyValue <= 100,
      };

      for (const errorMessage in validateTable) {
        if (!validateTable[errorMessage]) {
          setBannerFeedbackEditorMessage(errorMessage);
          setBannerFeedbackEditorType("error");
          setBannerFeedbackEditorIsOpen(true);
          setLoading(false);
          return;
        }
      }

      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      const numMediasInAd = Object.keys(mapFilesImages.current).length;
      const data: { [key: string]: any } = {
        label: label,
        components: JSON.stringify(generalComponent),
        tags: tags,
        isAdult: creativeAdultFlag(isAdult, orgIsOnlyForAdults),
        active: active,
        numMediasInAd: numMediasInAd,
      };

      if (openFrequency) {
        data["percentageRate"] = frequencyValue;
      }

      if (headline.trim()) {
        data["headline"] = headline;
      }

      try {
        await ensureHallAdFonts(refinedComponents);
        const res = await adsAPI.post("/hall", data, { headers: headers });
        const id = res.data.id as string;

        if (!numMediasInAd) {
          setBannerFeedbackType("success");
          setBannerFeedbackMessage("Anúncio criado com sucesso");
          setBannerFeedbackIsOpen(true);
          setDetailState(undefined);
          APIEvents.listHallAds();
          return false;
        }

        setBannerFeedbackEditorMessage("Iniciando tratamento das imagens...");
        setBannerFeedbackEditorType("info");
        setBannerFeedbackEditorIsOpen(true);

        for (const [mediaId, file] of Object.entries(mapFilesImages.current)) {
          const ticketId = `hall-${id}`;
          const { promise } = createTurboUpload({
            ticketId,
            file,
            mediaId,
            mediaType: "image",
            section: "hallAd",
            identifiers: { hallAdId: id },
            getToken: () => Promise.resolve(localforage.getItem("JWT") as Promise<string>),
          });

          const result = await promise;
          if (!result.ok) {
            if (result.backlog) {
              // Backlog cap: a friendly "na fila" notice, never a red error.
              setBannerFeedbackEditorType("info");
              setBannerFeedbackEditorMessage(UPLOAD_BACKLOG_NOTICE);
              setBannerFeedbackEditorIsOpen(true);
              return;
            }
            console.error(result);
            setBannerFeedbackEditorType("error");
            setBannerFeedbackEditorMessage(
              getUserFacingError(result, {
                context: "upload",
                fallback: "Não foi possível enviar a imagem. Confira o arquivo e tente novamente.",
              }),
            );
            setBannerFeedbackEditorIsOpen(true);
            return;
          }
        }

        setDetailState(undefined);
        // Mirror the no-media branch above: refresh the list from the server so
        // the new ad shows without depending on the fragile RTA socket event.
        APIEvents.listHallAds();
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackEditorType("error");
        setBannerFeedbackEditorIsOpen(true);

        setBannerFeedbackEditorMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível criar o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        setLoading(false);
      }
    }

    async function editHallAd() {
      setLoading(true);
      const JWT = (await localforage.getItem("JWT")) as string | undefined;
      if (!JWT) return;

      const headers = {
        "X-JWT": JWT,
      };

      // Editing an existing creative updates campaign metadata only.
      const componentsWithoutBg = components.filter((component) => component.type !== "background");

      const validateTable: { [key: string]: boolean } = {
        "A label precisa ser preenchida": label.trim().length > 0,
        "A label pode ter no máximo 50 caracteres": label.trim().length <= 50,
        "A headline pode ter no máximo 60 caracteres":
          !headline.trim() || headline.trim().length <= 60,
        "O anúncio está vazio": componentsWithoutBg.length > 0,
        "Precisam ter no minimo 3 tags": tags.length >= 3,
        "Precisam ter no máximo 7 tags": tags.length <= 7,
        "A taxa de frequência precisa ser maior que 0%": !openFrequency || frequencyValue > 0,
        "A soma das taxas de frequência não pode ser maior que 100%":
          !openFrequency ||
          calculateSumPercentageRateByTargetAdId(
            ads,
            chosedAd!.id,
            openFrequency ? frequencyValue : 0,
          ) <= 100,
      };

      for (const errorMessage in validateTable) {
        if (!validateTable[errorMessage]) {
          setBannerFeedbackEditorType("error");
          setBannerFeedbackEditorMessage(errorMessage);
          setBannerFeedbackEditorIsOpen(true);
          setLoading(false);
          return;
        }
      }

      const data: { [key: string]: any } = {
        id: chosedAd!.id,
        label: label,
        tags: tags,
        isAdult: creativeAdultFlag(isAdult, orgIsOnlyForAdults),
        active: active,
      };

      if (openFrequency) {
        data["percentageRate"] = frequencyValue;
      }

      if (headline.trim()) {
        data["headline"] = headline;
      }

      try {
        await adsAPI.patch(`/hall`, data, { headers: headers });
        setBannerFeedbackType("success");
        setBannerFeedbackMessage("Anúncio editado com sucesso");
        setBannerFeedbackIsOpen(true);
        setDetailState(undefined);
        APIEvents.listHallAds();
      } catch (err: any) {
        console.error(err);
        setBannerFeedbackEditorType("error");
        setBannerFeedbackEditorIsOpen(true);

        setBannerFeedbackEditorMessage(
          getUserFacingError(err, {
            context: "ads",
            fallback: "Não foi possível editar o anúncio agora. Tente novamente em instantes.",
          }),
        );
      } finally {
        setLoading(false);
      }
    }

    if (!detailState) {
      return <></>;
    }

    return (
      <div className="hallCreateContainer" onMouseDown={clickOutside}>
        <div className="hallPreviewContainer" onMouseDown={clickOutside}>
          <div className="hallExtraEditor">
            <TextField
              class="hallLabelAd"
              placeholder="Nome do anúncio"
              icon={<LabelRounded />}
              onInput={(e) => setLabel((e.target as HTMLInputElement).value)}
              defaultValue={label}
              maxLength={50}
            />
            <FormGroup>
              <FormControlLabel
                className="switchAd"
                control={
                  <Switch color="warning" onChange={() => setActive(!active)} checked={active} />
                }
                label="Ativo para circulação"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    color: "var(--neutral-12) !important",
                    fontWeight: 400,
                  },
                }}
              />
              {!orgIsOnlyForAdults && (
                <FormControlLabel
                  className="switchAd"
                  control={
                    <Switch
                      color="warning"
                      onChange={() => setIsAdult(!isAdult)}
                      checked={isAdult}
                    />
                  }
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "var(--neutral-12) !important",
                      fontWeight: 400,
                    },
                  }}
                  label="Anúncio para adultos"
                />
              )}
              {active && (
                <div className="frequencyAdContainer">
                  <FormControlLabel
                    className="switchAd"
                    control={
                      <Switch
                        color="warning"
                        onChange={() => setOpenFrequency(!openFrequency)}
                        checked={openFrequency}
                      />
                    }
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        color: "var(--neutral-12) !important",
                        fontWeight: 400,
                      },
                    }}
                    label="Personalizar frequência dos anúncios"
                  />
                  <InfoPopup
                    position={"nw"}
                    id="infoFrequencyHallAd"
                    classNameBox="infoFrequencyAdBoxContainer"
                    triggerElement={
                      <FontAwesomeIcon
                        icon={faCircleInfo}
                        className="infoIconFrequencyAd infoIconFrequencyHallAd"
                      />
                    }
                  >
                    <span>
                      Definindo a frequência, esse anúncio será exibido apenas na porcentagem
                      definida por você. Portanto não se deve colocar um valor muito alto se já
                      houver outros anúncios com frequência personalizada, para não ultrapassar 100%
                      de exibição.
                    </span>
                  </InfoPopup>
                </div>
              )}
            </FormGroup>
            {openFrequency && active && (
              <Stack
                direction="row"
                spacing={2}
                sx={{ alignItems: "center", mb: 1, width: "100%" }}
              >
                <span>0%</span>
                <Slider
                  color="warning"
                  step={1}
                  min={0}
                  max={100}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `${value}%`}
                  value={frequencyValue}
                  onChange={(_, value) => setFrequencyValue(value as number)}
                  aria-label="frequencyHallAd"
                />
                <span>100%</span>
              </Stack>
            )}
            <InputTags
              id="inputTagsHall"
              minTags={3}
              initialValue={tags}
              onChange={(tags: string[]) => setTags(tags)}
              onError={(error: string) => {
                setBannerFeedbackEditorType("error");
                setBannerFeedbackEditorMessage(error);
                setBannerFeedbackEditorIsOpen(true);
              }}
            />
            <textarea
              className="hallAdHeadlineText"
              placeholder="Escreva o headline do anúncio..."
              rows={2}
              maxLength={60}
              onInput={(e) => setHeadline((e.target as HTMLTextAreaElement).value)}
              defaultValue={headline}
            />
            <div className="buttonsStateHall">
              <Button
                type="brand"
                class={
                  detailState === "create"
                    ? disableCreate()
                      ? ""
                      : "hallSaveButton"
                    : disableEdit()
                      ? ""
                      : "hallSaveButton"
                }
                callback={detailState === "create" ? createHallAd : editHallAd}
                loading={{ state: loading, text: "Salvando" }}
                icon={detailState === "create" ? <AddIcon /> : <EditRounded />}
                iconSlot="start"
                disabled={detailState === "create" ? disableCreate() : disableEdit()}
              >
                {detailState === "create" ? "Criar" : "Editar"}
              </Button>
              {detailState === "create" ? (
                <button
                  onMouseDown={startCancelling}
                  className="hallCancelButton"
                  style={{
                    transform: cancelling ? "scale(1.05)" : "scale(1)",
                  }}
                >
                  {cancelling ? (
                    <>
                      <TimerRounded />
                      <span>Cancelando...</span>
                    </>
                  ) : (
                    <>
                      <CloseRoundedIcon />
                      <span>Pressione para cancelar</span>
                    </>
                  )}
                </button>
              ) : (
                <button onMouseDown={() => setDetailState(undefined)} className="hallCancelButton">
                  <CloseRoundedIcon />
                  <span>Cancelar</span>
                </button>
              )}
            </div>
          </div>
          {detailState === "create" && (
            <div id="hallScreenEditorContainer" onMouseDown={clickOutside}>
              <BannerFeedback
                type={bannerFeedbackEditorType}
                open={bannerFeedbackEditorIsOpen}
                message={bannerFeedbackEditorMessage}
                callback={() => setBannerFeedbackEditorIsOpen(false)}
                sx={{
                  maxWidth: "var(--width-xl)",
                }}
              />
              <div id="hallCreationItemsEditorContainer">
                <div className="hallCreationItem" onClick={HallComponent.initNewButton}>
                  <SmartButtonRounded />
                  <span>Botão</span>
                </div>
                <hr />
                <div className="hallCreationItem" onClick={HallComponent.initNewText}>
                  <AbcSharp />
                  <span>Texto</span>
                </div>
                <hr />
                <label className="hallCreationItem" htmlFor="hallCreationItemFile">
                  <ImageRounded />
                  <span>Imagem</span>
                  <input
                    id="hallCreationItemFile"
                    type="file"
                    accept="image/*"
                    onChange={HallComponent.initNewImage}
                    hidden
                  />
                </label>
                <hr />
                <div className="hallCreationItem" onClick={HallComponent.configureBackgroundCard}>
                  <PaletteRounded />
                  <span>Background</span>
                </div>
              </div>
              <div className="hallScreenEditors" onMouseDown={clickOutside}>
                <div
                  id="hallScreenEditorContent"
                  className="authoredAdCanvas"
                  data-authored-canvas
                  onMouseDown={selectBackground}
                  style={{
                    ...hallAdBackground(
                      components.find((component) => component.type === "background")?.css,
                    ),
                    outline:
                      selectedComponent?.type === "background" ? "2px dashed #1ab8a3" : "none",
                  }}
                >
                  {components
                    .filter((component) => component.type !== "background")
                    .map((component) => {
                      const displayCss = hallAdStyle(component.type, component.css);

                      return (
                        <div
                          key={component.id}
                          className="hallCreationComponent"
                          style={{
                            zIndex: component.zIndex,
                          }}
                        >
                          <div
                            className="hallItemComponentContainer"
                            id={`hallItemComponent_${component.id}`}
                            style={{
                              top: `${component.y}px`,
                              left: `${component.x}px`,
                              transform: `rotate(${component.rotation}deg)`,
                              transformOrigin: displayCss.transformOrigin,
                              width: displayCss.width,
                              height: displayCss.height,
                              cursor: inGrab ? "grabbing" : "grab",
                            }}
                            onMouseDown={GrabSelected.start}
                          >
                            {selectedComponent?.id === component.id &&
                              selectedComponent.type !== "background" && (
                                <div className="hallItemSelected">
                                  <div className="hallItemSelectedRotateContainer">
                                    <div
                                      className="hallCirclePointRotator"
                                      onMouseDown={RotateSelected.start}
                                    />
                                    <div className="lineConnectPointRotator" />
                                  </div>
                                  <div
                                    className="cornerPointerScale rightBottomPointerScale"
                                    onMouseDown={SelectDimension.start}
                                  />
                                </div>
                              )}
                            {component.type === "button" && (
                              <button className="hallItemButton" style={displayCss}>
                                {component.text}
                              </button>
                            )}
                            {component.type === "text" && (
                              <span className="hallItemText" style={displayCss}>
                                {component.text}
                              </span>
                            )}
                            {component.type === "image" && (
                              <img
                                className="hallItemImage"
                                src={component.preview}
                                style={displayCss}
                                alt="anuncio_hall"
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
                <SelectedComponent
                  selectedComponent={selectedComponent as HallAdComponentProps}
                  modifiedAd={HallComponent.editComponent}
                  callbackDeleteAd={(id) => {
                    setComponents(components.filter((component) => component.id !== id));
                    setSelectedComponent(undefined);
                    mapFilesImages.current[id] && delete mapFilesImages.current[id];
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  React.useEffect(() => {
    RTA.connect();
    let cleanup = () => {};
    let isActive = true;
    sessionInfo()
      .then((info) => {
        if (!isActive || !info) return false;
        const receiveEvent = `receiveNewUploadItem-${info.org_id}`;
        const concludeEvent = `concludeUploadItem-${info.org_id}`;

        RTA.on(receiveEvent, SocketEvents.receiveNewUploadItem);
        RTA.on(concludeEvent, SocketEvents.concludeUploadItem);

        cleanup = () => {
          RTA.off(receiveEvent, SocketEvents.receiveNewUploadItem);
          RTA.off(concludeEvent, SocketEvents.concludeUploadItem);
        };
      })
      .catch((err) => {
        console.error("Error retrieving session info:", err);
      });
    return () => {
      isActive = false;
      cleanup();
    };
  }, []);

  React.useEffect(() => {
    APIEvents.listHallAds();
  }, [search, activeFilter]);
  return (
    <>
      <HallEditor />
      <div className="adsPageContainer">
        <br />
        <Title title="Átrio" subtitle="Gerencie os anúncios do Átrio" />
        <br />
        <BannerFeedback
          type={bannerFeedbackType}
          open={bannerFeedbackIsOpen}
          message={bannerFeedbackMessage}
          callback={() => setBannerFeedbackIsOpen(false)}
          sx={{
            width: "100%",
          }}
        />
        <div className="adsActionRow">
          <div className="featureOptionAds">
            {checkPermission(permissions.hallAds, "create") && (
              <Button
                icon={<AddIcon />}
                iconSlot="start"
                type="brand"
                class="addAds"
                callback={() => setDetailState("create")}
              >
                Criar Anúncio
              </Button>
            )}
            <Select
              containerId="filterActiveHall"
              idBox="filterActiveHallBox"
              classNameBox="filterActiveAdBox"
              className="filterActiveAd"
              label="atrio"
              options={["Ativo", "Inativo"]}
              optionsValues={["active", "inactive"]}
              iconArrow={<ChevronDownIcon />}
              selectValue={(value) => setActiveFilter(value === "active" ? true : false)}
              defaultValue={activeFilter ? "active" : "inactive"}
            />
          </div>
          <TextField
            id="searchHall"
            class="searchAd"
            placeholder="Procurar"
            icon={<SearchRoundedIcon />}
            onInput={triggerSearchTime}
            clear
          />
        </div>
        <div className="adsList">
          {ads.map((ad, index) => {
            if (ad.active !== activeFilter) return null;
            const canEdit = checkPermission(permissions.hallAds, "edit");
            const canDelete = checkPermission(permissions.hallAds, "delete");

            // On mobile the 360×540 absolute-positioned ad canvas can't
            // scale reliably via CSS (children use fixed px coords).
            // Render a compact row with the ad label + Edit/Delete
            // actions inline instead — fidelity preview is for desktop.
            if (isMobile) {
              return (
                <div className="hallAdMobileRow" key={index}>
                  <span className="hallAdMobileLabel">{ad.label}</span>
                  {ad.percentageRate && (
                    <span className="hallAdMobilePercentage">{ad.percentageRate}%</span>
                  )}
                  {(canEdit || canDelete) && (
                    <div className="hallAdMobileActions">
                      {canEdit && (
                        <button
                          className="hallAdConfigButton hallAdConfigButtonEdit"
                          onClick={() => {
                            setDetailState("edit");
                            candidateAdId.current = ad.id;
                          }}
                          aria-label="Editar"
                        >
                          <EditRounded />
                        </button>
                      )}
                      {canDelete && (
                        <button
                          className="hallAdConfigButton hallAdConfigButtonDelete"
                          onClick={() => APIEvents.deleteHallAd(ad.id)}
                          aria-label="Deletar"
                        >
                          <DeleteRounded />
                        </button>
                      )}
                    </div>
                  )}
                </div>
              );
            }

            const parsedComponents = parseHallAdComponents(ad.components);
            if (!parsedComponents) {
              // Malformed components payload — render a safe placeholder row so
              // one bad ad doesn't take down the entire Átrio list.
              return (
                <div className="hallAdViewContainer hallAdViewInvalid" key={index}>
                  <div className="hallAdViewLabel">{ad.label}</div>
                  {(canEdit || canDelete) && (
                    <div className="hallAdConfig">
                      {canEdit && (
                        <button
                          className="hallAdConfigButton hallAdConfigButtonEdit"
                          onClick={() => {
                            setDetailState("edit");
                            candidateAdId.current = ad.id;
                          }}
                        >
                          Editar
                          <EditRounded />
                        </button>
                      )}
                      {canDelete && (
                        <button
                          className="hallAdConfigButton hallAdConfigButtonDelete"
                          onClick={() => APIEvents.deleteHallAd(ad.id)}
                        >
                          Deletar
                          <DeleteRounded />
                        </button>
                      )}
                    </div>
                  )}
                  <div className="hallAdViewPreview hallAdViewPreviewInvalid">
                    <span>Não foi possível carregar a prévia deste anúncio.</span>
                  </div>
                </div>
              );
            }

            return (
              <div className="hallAdViewContainer" key={index}>
                <div className="hallAdViewLabel">{ad.label}</div>
                {ad.percentageRate && (
                  <div className="hallAdViewPercentage">{ad.percentageRate}%</div>
                )}
                {(canEdit || canDelete) && (
                  <div className="hallAdConfig">
                    {canEdit && (
                      <button
                        className="hallAdConfigButton hallAdConfigButtonEdit"
                        onClick={() => {
                          setDetailState("edit");
                          candidateAdId.current = ad.id;
                        }}
                      >
                        Editar
                        <EditRounded />
                      </button>
                    )}
                    {canDelete && (
                      <button
                        className="hallAdConfigButton hallAdConfigButtonDelete"
                        onClick={() => APIEvents.deleteHallAd(ad.id)}
                      >
                        Deletar
                        <DeleteRounded />
                      </button>
                    )}
                  </div>
                )}
                <div
                  className="hallAdViewPreview authoredAdCanvas"
                  data-authored-canvas
                  style={hallAdBackground(parsedComponents.background)}
                >
                  {parsedComponents.components.map((part: HallAdComponentProps, index: number) => {
                    const component = toCanvasAdPart(part);
                    return (
                      <div key={index} className="hallAdComponent">
                        {component.type === "button" && (
                          <button
                            className="hallAdButton hallAdComponent"
                            style={{
                              ...component.css,
                              position: "absolute",
                              top: `${component.y}px`,
                              left: `${component.x}px`,
                              zIndex: component.zIndex,
                            }}
                          >
                            {component.text}
                          </button>
                        )}
                        {component.type === "text" && (
                          <span
                            className="hallAdText hallAdComponent"
                            style={{
                              ...component.css,
                              position: "absolute",
                              top: `${component.y}px`,
                              left: `${component.x}px`,
                              zIndex: component.zIndex,
                            }}
                          >
                            {component.text}
                          </span>
                        )}
                        {component.type === "image" && (
                          <img
                            className="hallAdImage hallAdComponent"
                            src={component.src}
                            style={{
                              ...component.css,
                              position: "absolute",
                              top: `${component.y}px`,
                              left: `${component.x}px`,
                              zIndex: component.zIndex,
                            }}
                            alt="anuncio_atrio"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export function Ads() {
  const { permissions } = usePermissions();
  const [indexTopic, setIndexTopic] = React.useState<number>();
  const [updateFlag, setUpdateFlag] = React.useState(false);

  const topic = React.useRef<
    {
      link: string;
      title: string;
      icon: JSX.Element;
    }[]
  >([]);

  React.useEffect(() => {
    topic.current = [];
    const canViewRadio = checkPermission(permissions.roomRadioAds, "view");
    const canViewTv = checkPermission(permissions.roomTvAds, "view");
    const canViewHall = checkPermission(permissions.hallAds, "view");
    const perm = [canViewRadio, canViewTv, canViewHall];
    const topics = [
      {
        link: "/anuncios/radio",
        title: "Rádio",
        icon: <RadioTwoToneIcon />,
      },
      {
        link: "/anuncios/tv",
        title: "TV",
        icon: <TvTwoToneIcon />,
      },
      {
        link: "/anuncios/atrio",
        title: "Átrio",
        icon: <AutoAwesomeTwoToneIcon />,
      },
    ];

    for (let i = 0; i < 3; i++) {
      if (!perm[i]) continue;
      topic.current.push(topics[i]);
      if (topics[i].link !== window.location.pathname) continue;
      setIndexTopic(i);
    }
    setUpdateFlag(!updateFlag);
  }, [permissions]);

  if (indexTopic === undefined) return <></>;
  return (
    <div id="adsPage">
      <Topics
        active={indexTopic}
        callback={(index) => setIndexTopic(index)}
        topic={topic.current}
      />
      <Outlet />
    </div>
  );
}
